<template>
  <div>
    <div class="row" v-if="!openDay">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>

        <template v-slot:2>
          <li class="breadcrumb-item active" aria-current="page">
            {{ $t("ventasPorNegocio") }}
          </li>
        </template>
      </breadcrumb>
      <CabeceraInformes v-if="sectores && $cookies.isKey('sectores')" :idBusiness="idBusiness"
        :listBusinesses="listBusinesses" :listSectores="listaSectores" :idTpv="idTpv" :idSector="idSector"
        :listTpv="listTpv" :dateto="dateto" :datefrom="datefrom" :hoursto="hoursto" :hoursfrom="hoursfrom"
        :conBusquedaPorHoras="true" :conTodos="true" :sectores="true" id="cabecera" :cargando="loadingResults" />
      <CabeceraInformes v-else :idBusiness="idBusiness" :idCompany="idCompany" :listCompanies="listCompanies"
        :listBusinesses="listBusinesses" :idTpv="idTpv" :listTpv="listTpv" :dateto="dateto" :datefrom="datefrom"
        :hoursto="hoursto" :hoursfrom="hoursfrom" :conBusquedaPorHoras="true" :conTodos="true" id="cabecera" :cargando="loadingResults" />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          {{ $t("loSentimos") }}. {{ $t("esteNegocioNoCuentaConModulo") }}.
        </div>
      </template>
      <div class="col-md-12" v-else>
        <template v-if="!loadingResults && searchPerformed && data.length > 0">
          <div class="export-controls-container">
            <div class="export-controls-left">
              <div class="export-dropdown-section">
                <el-dropdown>
                  <el-button type="primary" size="small">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarInforme")
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>

                  <el-dropdown-menu v-if="graficaVentas === 0" slot="dropdown">
                    <a :href="urlExportPDF">
                      <el-dropdown-item class="text-danger">
                        <strong><i class="fa fa-file-pdf"></i>
                          {{ $t("exportarPdf") }}</strong>
                      </el-dropdown-item>
                    </a>
                    <a :href="urlExportExcel">
                      <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                          {{ $t("exportarExcel") }}</strong>
                      </el-dropdown-item>
                    </a>
                    <a v-if="despachos" :href="urlExportDespachos">
                      <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                          Exportar SAGE Despachos</strong>
                      </el-dropdown-item>
                    </a>
                    <a v-if="despachos" @click="exportar = true" :href="urlExportDespachosFecha">
                      <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                          Exportar SAGE Despachos por Fechas</strong>
                      </el-dropdown-item>
                    </a>
                    <template v-if="graficaMesas">
                      <a :href="urlExportExcelCompleto">
                        <el-dropdown-item class="text-success">
                          <strong><i class="fa fa-file-excel"></i>
                            Exportar informe facturación general</strong>
                        </el-dropdown-item>
                      </a>
                      <a v-if="busquedaPorHoras && graficaMesas" :href="urlExportExcelHorasYMesas">
                        <el-dropdown-item class="text-success">
                          <strong><i class="fa fa-file-excel"></i>
                            Exportar informe ventas por horas y mesas</strong>
                        </el-dropdown-item>
                      </a>
                    </template>
                  </el-dropdown-menu>
                  <el-dropdown-menu v-else slot="dropdown">
                    <a :href="urlExportPDFInformes">
                      <el-dropdown-item class="text-danger">
                        <strong><i class="fa fa-file-pdf"></i>
                          {{ $t("exportarPdf") }}</strong>
                      </el-dropdown-item>
                    </a>
                    <a :href="urlExportExcelInformes">
                      <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                          {{ $t("exportarExcel") }}</strong>
                      </el-dropdown-item>
                    </a>
                    <a v-if="despachos" :href="urlExportDespachos">
                      <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                          {{ $t("exportarExcel") }}</strong>
                      </el-dropdown-item>
                    </a>
                    <a v-if="graficaMesas" :href="urlExportExcelCompleto">
                      <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                          Exportar informe facturación general</strong>
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>

                <!-- Botón para obtener ventas por horas y mesas (Valderrama y otros) -->
                <el-button v-if="busquedaPorHoras && graficaMesas" type="success" size="small"
                  :loading="loadingHourlyData" @click="getVentasPorHorasYMesas" class="ventas-por-horas-btn">
                  <i class="fas fa-clock"></i>
                  {{ $t("ventasPorHorasYMesas") }}
                </el-button>

                <!-- Selector de filtro al lado del dropdown -->
                <div v-if="filterSelected == 5 && graficaMesas && busquedaPorHoras" class="filter-selector">
                  <el-select class="select-default filterTag" size="small" v-model="filter" @change="getSalesMesas()"
                    :placeholder="$t('seleccionaNegocio')">
                    <el-option v-for="filter in filterTag" class="select-primary" :value="filter.value"
                      :label="filter.label" :key="filter.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="export-controls-right">
              <!--
              // Checkbox para mostrar o no las ventas de un día acumuladas en una fila de la tabla. 🌵☀️
              // 1.- El usuario marca/desmarca el checkbox mostrarVentasAcumuladasPorDia y se dispara el evento @change y se actualiza el valor del atributo de clase ventasAcumuladasPorDia (boolean).
              // 2.- Se llama al método getVentasSinHoras() para obtener de nuevo las ventas.
              // 3.- Se vuelve a rellenar la tabla pero esta vez entramos en la condición de que ventasAcumuladasPorDia es true, y por tanto acumula los valores por día antes de saltar de fila.
              -->
              <div class="checkbox-section">
                <el-checkbox v-model="ventasAcumuladasPorDia" @change="getVentasSinHoras()">
                  <strong>{{ $t("mostrarVentasAcumuladasPorDia") }}</strong>
                </el-checkbox>
              </div>

              <!-- Filtros dias/semanas/meses/horas | mesas/gráfica -->
              <div class="button-group-container">
                <el-button-group class="filter-button-group">
                  <el-button :class="{ 'active-filter': styleCheckFilter(0) }" @click="openDays()" size="small">
                    {{ $t("dias") }}
                  </el-button>
                  <el-button :class="{ 'active-filter': styleCheckFilter(1) }" @click="openSemanas()" size="small">
                    {{ $t("semanas") }}
                  </el-button>
                  <el-button :class="{ 'active-filter': styleCheckFilter(2) }" @click="openMeses()" size="small">
                    {{ $t("meses") }}
                  </el-button>
                  <el-button :class="{ 'active-filter': styleCheckFilter(4) }" @click="openHours()" size="small">
                    {{ $t("horas") }}
                  </el-button>
                  <el-button :class="{ 'active-filter-mesas': styleCheckFilter(5) }" type="warning"
                    @click="buttonGraficaMesas" size="small" icon="fas fa-scroll">
                    {{ $t("mesas") }}
                  </el-button>
                  <el-button v-if="grafica === 0" @click="buttonGrafica" type="primary" size="small"
                    icon="fas fa-chart-bar">
                    {{ $t("grafica") }}
                  </el-button>

                  <el-button v-else type="primary" @click="buttonGrafica" size="small" icon="fas fa-list-ul">
                    {{ $t("lista") }}
                  </el-button>
                </el-button-group>
              </div>
            </div>
          </div>
          <div class="col-md-12 consultarSwitch text-right" v-show="filterSelected === 4">
            <span>{{ $t("informeAperturaCuentas") }}</span>
            <el-switch v-model="consultarInicioCuenta" active-color="#13ce66" inactive-color="#bcbcbc">
            </el-switch>
            <!--<el-checkbox v-model="consultarInicioCuenta">Consultar por inicio de cuenta</el-checkbox>-->
          </div>

          <div v-show="grafica === 0" class="table-responsive">
            <div v-show="graficaVentas === 0">
              <template v-if="!graficaMesas">
                <table class="table table-bordered table-striped tableVentas text-nowrap">
                  <thead class="thead-dark">
                    <tr style="cursor: pointer;">
                      <th v-if="ordenacionFecha === 0" @click="sortedArrayFechaASC('initDate')">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("fecha") }}
                      </th>
                      <th v-else @click="sortedArrayFechaDESC('initDate')">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("fecha") }}
                      </th>

                      <th v-if="ordenarVentas === 0" @click="sortedArrayVentasASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("ventas") }}
                      </th>
                      <th v-else @click="sortedArrayVentasDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("ventas") }}
                      </th>

                      <th v-if="ordenarEfectivo === 0" @click="sortedArrayEfectivoASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("efectivo") }}
                      </th>
                      <th v-else @click="sortedArrayEfectivoDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("efectivo") }}
                      </th>

                      <th v-if="ordenarTarjetas === 0" @click="sortedArrayTarjetasASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("tarjetas") }}
                      </th>
                      <th v-else @click="sortedArrayTarjetasDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("tarjetas") }}
                      </th>
                      <th v-if="ordenarCheque === 0" @click="sortedArrayChequeASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("cheque") }}
                      </th>
                      <th v-else @click="sortedArrayChequeDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("cheque") }}
                      </th>
                      <th v-if="ordenarPropina === 0" @click="sortedArrayPropinaASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("propina") }}
                      </th>
                      <th v-else @click="sortedArrayPropinaDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("propina") }}
                      </th>
                      <th v-if="ordenarBalance === 0 && dimoni" @click="sortedArrayBalanceASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("pagosaldo") }}
                      </th>
                      <th v-else-if="dimoni" @click="sortedArrayBalanceDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("pagosaldo") }}
                      </th>
                      <th v-if="ordenarGastos === 0" @click="sortedArrayGastosASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("gastos") }}
                      </th>
                      <th v-else @click="sortedArrayGastosDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("gastos") }}
                      </th>
                      <th v-if="ordenarCambio === 0" @click="sortedArrayCambioASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("cambio") }}
                      </th>
                      <th v-else @click="sortedArrayCambioDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("cambio") }}
                      </th>

                      <th v-if="ordenarRetiradas === 0" @click="sortedArrayCambioASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("retiradas") }}
                      </th>
                      <th v-else @click="sortedArrayCambioDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("retiradas") }}
                      </th>

                      <th v-if="ordenarTotal === 0" @click="sortedArrayTotalASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("total") }}
                      </th>
                      <th v-else @click="sortedArrayTotalDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("total") }}
                      </th>
                      <th v-if="!hideColumns">
                        <span v-if="ordenarRecuento === 0" @click="sortedArrayRecuentoASC()">
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("recuento") }}
                        </span>
                        <span v-else @click="sortedArrayRecuentoDESC()">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("recuento") }}
                        </span>
                      </th>

                      <th v-if="!hideColumns">
                        <span v-if="ordenarDescuadre === 0" @click="sortedArrayDescuadreASC()">
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("descuadre") }}
                        </span>
                        <span v-else @click="sortedArrayDescuadreDESC()">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("descuadre") }}
                        </span>
                      </th>

                      <!-- 
                      <th v-if="ordenarDescuadre === 0" @click="sortedArrayDescuadreASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("descuadre") }}
                      </th>
                      <th v-else @click="sortedArrayDescuadreDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("descuadre") }}
                      </th> 
                      -->

                      <th v-if="!hideColumns">
                        <span v-if="ordenarSiguienteDia === 0" @click="sortedArraySiguienteDiaASC()">
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("siguienteDia") }}
                        </span>
                        <span v-else @click="sortedArraySiguienteDiaDESC()">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("siguienteDia") }}
                        </span>
                      </th>

                      <!--  
                      <th v-if="ordenarSiguienteDia === 0" @click="sortedArraySiguienteDiaASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("siguienteDia") }}
                      </th>
                      <th v-else @click="sortedArraySiguienteDiaDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("siguienteDia") }}
                      </th> 
                      -->

                      <th v-if="!hideColumns"> <span v-if="ordenarIncidencias === 0"
                          @click="sortedArrayIncidenciasASC()">
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("incidencias") }}
                        </span>
                        <span v-else @click="sortedArrayIncidenciasDESC()">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("incidencias") }}
                        </span>
                      </th>

                      <!--                     
                      <th v-if="ordenarIncidencias === 0" @click="sortedArrayIncidenciasASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("incidencias") }}
                      </th>
                      <th v-else @click="sortedArrayIncidenciasDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("incidencias") }}
                      </th> 
                      -->

                      <th v-if="ordenarRecaudado === 0" @click="sortedArrayRecaudadoASC()">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("recaudado") }}
                      </th>
                      <th v-else @click="sortedArrayRecaudadoDESC()">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("recaudado") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>

                    <!--
                    1.- Utiliza el método acumularVentasPorDia() en lugar de iterar directamente sobre data en el v-for. 
                    2.- En este método, se evalua si ventasAcumuladasPorDiacaso es true o false. 
                      2.1.- Si es false, itera sobre todas ventas directamente y las añade a la tabla
                      2.2.- Si es true, acumula primero los valores de la venta por día y luego añade a cada fila los valores acumulados.  
                    -->
                    <tr v-for="(obj, index) in acumularVentasPorDia()" :key="index" style="cursor: pointer"
                      @click="handleClick(obj)" class="trDay">

                      <template v-if="graficaVentas === 1">
                        <td>
                          <span :class="getClassDay(obj.initDate)">{{
                            obj.initDate | getDiaDeSemana
                          }}</span>
                        </td>
                      </template>
                      <template v-else-if="graficaVentas === 2">
                        <td>
                          <span>{{ obj.initDate | parseYear }}</span>
                        </td>
                      </template>
                      <template v-else-if="graficaVentas === 3">
                        <td>
                          <span> {{ obj.initDate | parseMonth }}</span>
                        </td>
                      </template>
                      <template v-else-if="graficaVentas === 4">
                        <td>
                          <span> {{ obj.initDate | parseHours }}</span>
                        </td>
                      </template>
                      <template v-else>
                        <td v-if="obj.observaciones">
                          <span :class="{
                            sunday: obj.initDate | (getDia == 'D'),
                            fridaySaturday: obj.initDate | (getDia == 'V'),
                            fridaySaturday: obj.initDate | (getDia == 'S'),
                          }">{{ obj.initDate | getDia }}
                            {{ obj.initDate | parseDate }}</span>
                          <i v-tooltip.top-center="obj.observaciones" style="color: #0976b4"
                            class="fa fa-info-circle"></i>
                        </td>
                        <td v-else>
                          <span :class="getClassDay(obj.initDate)">{{ obj.initDate | getDia }}
                            {{ obj.initDate | parseDate }}</span>
                        </td>
                      </template>
                      <td class="table-success" align="right" v-if="!dimoni">
                        {{ (obj.money + obj.cards + obj.checks) | currency }}
                      </td>
                      <td class="table-success" align="right" v-else>
                        {{ (obj.money + obj.cards + obj.checks + obj.balance) | currency }}
                      </td>
                      <td align="right">{{ obj.money | currency }}</td>
                      <td align="right">{{ obj.cards | currency }}</td>
                      <td align="right">{{ obj.checks | currency }}</td>
                      <td align="right">{{ obj.propina | currency }}</td>
                      <td align="right" v-if="dimoni">{{ obj.balance | currency }}</td>
                      <td class="table-danger" align="right">
                        {{ obj.cashExpenses | currency }}
                      </td>
                      <td align="right">{{ obj.cashChange | currency }}</td>
                      <td class="table-danger" align="right">
                        {{ obj.retiradas | currency }}
                      </td>
                      <td align="right" v-if="!dimoni">
                        {{
                          (obj.money +
                            obj.cards +
                            obj.checks -
                            obj.cashExpenses +
                            obj.cashChange -
                            obj.retiradas)
                          | currency
                        }}
                      </td>
                      <td align="right" v-else>
                        {{
                          (obj.money +
                            obj.cards +
                            obj.checks +
                            obj.balance -
                            obj.cashExpenses +
                            obj.cashChange -
                            obj.retiradas)
                          | currency
                        }}
                      </td>
                      <td align="right" v-if="!hideColumns">
                        <template v-if="obj.countAmount !== 0">{{ (obj.countAmount - obj.retiradas) | currency }}
                        </template>
                        <template v-else>{{
                          obj.countAmount | currency
                        }}</template>
                      </td>

                      <td v-if="!hideColumns" align="right">
                        <span v-if="obj.countAmount !== 0" align="right">

                          <span v-if="
                            (obj.cashExpenses + obj.countAmount).toFixed(2) -
                            (
                              obj.money +
                              obj.cards +
                              obj.checks +
                              obj.cashChange +
                              obj.balance
                            ).toFixed(2) >=
                            0
                          " style="color: green">{{
                            ((obj.countAmount + obj.cashExpenses).toFixed(2) -
                              (
                                obj.money +
                                obj.cards +
                                obj.checks +
                                obj.cashChange +
                                obj.balance
                              ).toFixed(2))
                            | currency
                          }}</span>
                          <span v-else style="color:red;">{{
                            ((obj.countAmount + obj.cashExpenses).toFixed(2) -
                              (
                                obj.money +
                                obj.cards +
                                obj.checks +
                                obj.cashChange +
                                obj.balance
                              ).toFixed(2))
                            | currency
                          }}</span>

                        </span>
                        <span align="right" v-else>{{ 0 | currency }}</span>
                      </td>


                      <td align="right" v-if="!hideColumns"> {{ obj.changeNextDay | currency }}</td>
                      <td align="right" v-if="!hideColumns">{{ obj.numIssues }}</td>


                      <td class="table-success" align="right" v-if="obj.countAmount !== 0">
                        {{ (obj.countAmount - obj.changeNextDay) | currency }}
                      </td>
                      <td v-else class="table-success" align="right"></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td class="table-success">
                        <strong>{{ $t("total") }}:</strong>
                      </td>
                      <td class="text-right table-success">
                        <strong>{{ getTotalVentas | currency }}</strong>
                      </td>
                      <td class="text-right">
                        <strong>{{ getTotalEfectivo | currency }}</strong>
                      </td>
                      <td class="text-right">
                        <strong>{{ getTotalTarjeta | currency }}</strong>
                      </td>
                      <td class="text-right">
                        <strong>{{ getTotalCheque | currency }}</strong>
                      </td>
                      <td class="text-right">
                        <strong>{{ getTotalPropina | currency }}</strong>
                      </td>
                      <td class="text-right" v-if="dimoni">
                        <strong>{{ getTotalBalance | currency }}</strong>
                      </td>
                      <td class="text-right table-danger">
                        <strong>{{ getTotalGastos | currency }}</strong>
                      </td>
                      <td class="text-right">
                        <strong>{{ getTotalCambio | currency }}</strong>
                      </td>
                      <td class="text-right table-danger">
                        <strong>{{ getTotalRetiradas | currency }}</strong>
                      </td>
                      <td class="text-right">
                        <strong>{{ getTotalTotal | currency }}</strong>
                      </td>
                      <td class="text-right" v-if="!hideColumns">
                        <strong>{{ getTotalRecuento | currency }}</strong>
                      </td>
                      <td class="text-right " v-if="!hideColumns">
                        <strong>{{ getTotalDescuadre | currency }}</strong>
                      </td>
                      <td class="text-right " v-if="!hideColumns">
                        <strong>{{ getTotalSiguiente | currency }}</strong>
                      </td>
                      <td class="text-right " v-if="!hideColumns">
                        <strong>{{ getTotalIncidencias }}</strong>
                      </td>
                      <td align="right" class="table-success">
                        <strong>{{ getTotalRecaudado | currency }}</strong>
                      </td>
                    </tr>
                    <tr class="table-warning">
                      <td class="table-success">
                        <strong>{{ $t("mediaSesion") }}:</strong>
                      </td>
                      <td class="text-right ">
                        <strong>{{ getTotalSesionMedia | currency }}</strong>
                        <i v-tooltip.top-center="$i18n.t(
                          'atencionLaMediaSinContarLosDiasConVentas'
                        ) +
                          getTotalVentasSinVentas +
                          ' €'
                          " style="color: darkred" class="fa fa-info-circle"></i>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td v-if="!hideColumns"></td>
                      <td v-if="!hideColumns"></td>
                      <td v-if="!hideColumns"></td>
                      <td v-if="!hideColumns"></td>
                      <td v-if="dimoni"></td>
                    </tr>
                  </tfoot>
                </table>
              </template>

              <template v-else>
                <div class="row">
                  <div class="col-md-4" v-for="sales in listMesasSales"
                    style="text-align:center; border:1px solid #eee; padding-top:10px;">
                    <span style="font-size:1.3em;"><strong>{{ sales.name }} / {{ sales.nametpv }}
                      </strong></span><br /><span class="text-success" style="font-size:1.5em;"><strong>{{ sales.amount
                        | currency
                      }}</strong></span><br /><span>Ticket Medio:
                      {{ (sales.amount / sales.servicios) | currency }}</span>
                    <div style="text-align:left; margin-top:10px;">

                      <table class="table table-striped table-bordered" role="grid">
                        <thead class="thead-dark">
                          <tr role="row" class="tablesorter-headerRow">
                            <th data-column="0" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("mesa") }}
                              </div>
                            </th>
                            <th data-column="1" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("ventas") }}
                              </div>
                            </th>
                            <th data-column="2" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("numServ") }}
                              </div>
                            </th>
                            <th data-column="3" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("ticketMed") }}
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody aria-live="polite" aria-relevant="all">
                          <tr role="row" v-for="mesas in sales.mesas">
                            <td style="text-align:right">{{ mesas.number }}</td>
                            <td style="text-align:right">
                              {{ mesas.amount | currency }}
                            </td>
                            <td style="text-align:right">
                              {{ mesas.ocupacion }}
                            </td>
                            <td style="text-align:right">
                              {{ (mesas.amount / mesas.ocupacion) | currency }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Tabla de totales por forma de pago y su desglose -->
                    <div style="text-align:left; margin-top:10px;">

                      <table class="table table-striped table-bordered" role="grid">
                        <thead class="thead-dark">
                          <tr role="row" class="tablesorter-headerRow">
                            <th data-column="0" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("totalCash") }}
                              </div>
                            </th>
                            <th data-column="1" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("totalCard") }}
                              </div>
                            </th>

                            <th data-column="2" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("totalCheque") }}
                              </div>
                            </th>

                            <!-- <th v-if="isValderrama" data-column="3" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("totalPagosaldo") }}
                              </div>
                            </th> -->

                            <th data-column="3" class="tablesorter-header tablesorter-headerUnSorted">
                              <div class="tablesorter-header-inner">
                                {{ $t("totalAvanzado") }}
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody aria-live="polite" aria-relevant="all">
                          <tr role="row" class="tablesorter-headerRow">
                            <td style="text-align:right">
                              {{ sales.totalEfectivo | currency }}
                            </td>
                            <td style="text-align:right">
                              {{ sales.totalTarjeta | currency }}
                            </td>
                            <td style="text-align:right">
                              {{ sales.totalCheque | currency }}
                            </td>
                            <!-- <td v-if="isValderrama" style="text-align:right">
                              {{ sales.totalPagoSaldo | currency }}
                            </td> -->
                            <td style="text-align:right">
                              {{ sales.totalAvanzado.total | currency }}
                            </td>
                          </tr>
                        </tbody>
                        <thead class="thead-dark">
                          <tr role="row" class="tablesorter-headerRow">
                            <th>{{ $t("avanzadoEfectivo") }}</th>
                            <th>{{ $t("avanzadoTarjeta") }}</th>
                            <th>{{ $t("avanzadoCheque") }}</th>
                            <!-- <th v-if="isValderrama">{{ $t("avanzadoPagosaldo") }}</th> -->
                            <th>{{ $t("avanzadoOtros") }}</th>
                          </tr>
                        </thead>
                        <tbody aria-live="polite" aria-relevant="all">
                          <!-- Fila con desglose de Total Avanzado -->
                          <tr role="row" class="tablesorter-headerRow">
                            <td style="text-align:right">
                              {{ sales.totalAvanzado.efectivo | currency }}
                            </td>
                            <td style="text-align:right">
                              {{ sales.totalAvanzado.tarjeta | currency }}
                            </td>
                            <td style="text-align:right">
                              {{ sales.totalAvanzado.cheque | currency }}
                            </td>
                            <!-- <td v-if="isValderrama" style="text-align:right">
                              {{ sales.totalAvanzado.pagoSaldo | currency }}
                            </td> -->
                            <td style="text-align:right">
                              {{ sales.totalAvanzado.otros | currency }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                  <div class="col-md-12 alert-success"
                    style="text-align:center;;font-size:1.5em; padding: 5px; margin-top: 10px; margin-bottom:10px">
                    <span class="text-success"><strong>{{ $t("total") }}:
                        {{ getTotalMesas | currency }}</strong></span>
                  </div>
                </div>

                <!-- Resultados de ventas por horas y mesas -->
                <div v-if="showHourlyData" class="col-md-12 mt-4 showHourlyData">
                  <div class="card">
                    <div class="card-header">
                      <div class="d-flex justify-content-between align-items-center">
                        <h4><i class="fas fa-clock"></i> {{ $t("desgloseVentasPorMesasHoras") }}
                        </h4>
                        <div v-if="availablePlanos.length > 0">
                          <el-select class="select-default" v-model="selectedPlano" size="small"
                            placeholder="Seleccionar Plano" style="width: 200px;">
                            <el-option value="all" label="Todos los Planos">
                            </el-option>
                            <el-option v-for="plano in availablePlanos" :key="plano.id" :value="plano.id"
                              :label="plano.name">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <!-- Mensaje cuando no hay ventas para el plano seleccionado -->
                      <div v-if="!filteredConsolidatedPostItTable && filteredRegularMesas.length === 0"
                        class="text-center py-4">
                        <div class="alert alert-success text-center">
                          <h3><i class="fas fa-check-circle"></i> {{ $t("noHayVentasDisponibles") }}.
                          </h3>
                          <p>{{ $t("intentaSeleccionarOtroPlano") }}.</p>
                        </div>
                      </div>

                      <!-- Tablas de mesas regulares -->
                      <div v-for="mesa in filteredRegularMesas" :key="`${mesa.idPlano}_${mesa.mesaNumber}`"
                        class="mb-4">
                        <div class="card">
                          <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <strong>{{ $t("mesa") }} {{ mesa.mesaNumber }}</strong> - <span class="text-muted">{{
                                  mesa.salonName
                                  }} / {{ mesa.nametpv }}</span>
                              </div>
                              <div>
                                <!-- <span class="badge badge-success mr-2">Ventas: €{{ getTotalVentasPositivas(mesa).toFixed(2) }}</span>
                                <span class="badge badge-danger mr-2">Cancelaciones: €{{ getTotalCancelaciones(mesa).toFixed(2) }}</span>
                                <span class="badge badge-info mr-2">Total Neto: €{{ mesa.totalAmount.toFixed(2) }}</span> -->
                                <span class="badge badge-warning mr-2">{{ $t("efectivo") }}: {{
                                  mesa.totalEfectivo.toFixed(2)
                                  }} €</span>
                                <span class="badge badge-primary mr-2">{{ $t("tarjeta") }}: {{
                                  mesa.totalTarjeta.toFixed(2)
                                  }} €</span>
                                <span class="badge badge-secondary mr-2">{{ $t("cheque") }}: {{
                                  mesa.totalCheque.toFixed(2) }} €</span>
                                <span v-if="isValderrama" class="badge badge-info">{{ $t("pagosaldo") }}: {{
                                  mesa.totalPagoSaldo.toFixed(2) }} €</span>
                              </div>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-striped table-bordered">
                                <thead class="thead-dark">
                                  <tr>
                                    <th>{{ $t("hora") }}</th>
                                    <th>{{ $t("ventas") }}</th>
                                    <th>{{ $t("cancelaciones") }}</th>
                                    <th>{{ $t("totalNeto") }}</th>
                                    <th>{{ $t("efectivo") }}</th>
                                    <th>{{ $t("tarjeta") }}</th>
                                    <th>{{ $t("cheque") }}</th>
                                    <th v-if="isValderrama">{{ $t("pagosaldo") }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="hora in Object.values(mesa.horas).sort((a, b) => a.hora - b.hora)"
                                    :key="hora.hora">
                                    <td><strong>{{ hora.hora }}:00</strong></td>
                                    <td class="text-right text-success">{{ hora.ventasPositivas.toFixed(2) }} €</td>
                                    <td class="text-right text-danger">{{ hora.cancelaciones.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.amount.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.efectivo.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.tarjeta.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.cheque.toFixed(2) }} €</td>
                                    <td v-if="isValderrama" class="text-right">{{ hora.pagoSaldo.toFixed(2) }} €</td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr class="table-info">
                                    <td><strong>{{ $t("totalMesa") }} {{ mesa.mesaNumber }}</strong></td>
                                    <td class="text-right text-success"><strong>{{
                                      getTotalVentasPositivas(mesa).toFixed(2) }} €</strong></td>
                                    <td class="text-right text-danger"><strong>{{
                                        getTotalCancelaciones(mesa).toFixed(2) }} €</strong></td>
                                    <td class="text-right"><strong>{{ mesa.totalAmount.toFixed(2) }} €</strong></td>
                                    <td class="text-right"><strong>{{ mesa.totalEfectivo.toFixed(2) }} €</strong></td>
                                    <td class="text-right"><strong>{{ mesa.totalTarjeta.toFixed(2) }} €</strong></td>
                                    <td class="text-right"><strong>{{ mesa.totalCheque.toFixed(2) }} €</strong></td>
                                    <td v-if="isValderrama" class="text-right"><strong>{{ mesa.totalPagoSaldo.toFixed(2)
                                        }} €</strong></td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Tabla consolidada de Post-it (si existe) -->
                      <div v-if="flatPostItTableData" class="mb-4">
                        <div class="card">
                          <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                              <div>
                                <strong>{{ $t("mesasDePostit") }}</strong>
                              </div>
                              <div>
                                <span class="badge badge-warning mr-2">{{ $t("efectivo") }}: {{
                                  flatPostItTableData.summary.totalEfectivo.toFixed(2) }} €</span>
                                <span class="badge badge-primary mr-2">{{ $t("tarjeta") }}: {{
                                  flatPostItTableData.summary.totalTarjeta.toFixed(2) }} €</span>
                                <span class="badge badge-secondary mr-2">{{ $t("cheque") }}: {{
                                  flatPostItTableData.summary.totalCheque.toFixed(2) }} €</span>
                                <span v-if="isValderrama" class="badge badge-info">{{ $t("pagosaldo") }}: {{
                                  flatPostItTableData.summary.totalPagoSaldo.toFixed(2) }} €</span>
                              </div>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-striped table-bordered">
                                <thead class="thead-dark">
                                  <tr>
                                    <th>{{ $t("identificadorPostit") }}</th>
                                    <th>{{ $t("hora") }}</th>
                                    <th>{{ $t("ventas") }}</th>
                                    <th>{{ $t("cancelaciones") }}</th>
                                    <th>{{ $t("totalNeto") }}</th>
                                    <th>{{ $t("efectivo") }}</th>
                                    <th>{{ $t("tarjeta") }}</th>
                                    <th>{{ $t("cheque") }}</th>
                                    <th v-if="isValderrama">{{ $t("pagosaldo") }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- Entradas horarias individuales para cada post-it -->
                                  <tr v-for="entry in flatPostItTableData.hourlyEntries"
                                    :key="`postit-${entry.postItName}-${entry.hora}`">
                                    <td>{{ entry.postItName }}</td>
                                    <td><strong>{{ entry.hora }}:00</strong></td>
                                    <td class="text-right text-success">{{ entry.ventasPositivas.toFixed(2) }} €</td>
                                    <td class="text-right text-danger">{{ entry.cancelaciones.toFixed(2) }} €</td>
                                    <td class="text-right">{{ entry.amount.toFixed(2) }} €</td>
                                    <td class="text-right">{{ entry.efectivo.toFixed(2) }} €</td>
                                    <td class="text-right">{{ entry.tarjeta.toFixed(2) }} €</td>
                                    <td class="text-right">{{ entry.cheque.toFixed(2) }} €</td>
                                    <td v-if="isValderrama" class="text-right">{{ entry.pagoSaldo.toFixed(2) }} €</td>
                                  </tr>
                                  <!-- Totales consolidados por hora -->
                                  <tr
                                    v-for="hora in Object.values(flatPostItTableData.consolidatedTotals).sort((a, b) => a.hora - b.hora)"
                                    :key="`consolidated-${hora.hora}`" class="table-warning">
                                    <td><em>{{ $t("totalConsolidado") }}</em></td>
                                    <td><strong>{{ hora.hora }}:00</strong></td>
                                    <td class="text-right text-success">{{ hora.ventasPositivas.toFixed(2) }} €</td>
                                    <td class="text-right text-danger">{{ hora.cancelaciones.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.amount.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.efectivo.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.tarjeta.toFixed(2) }} €</td>
                                    <td class="text-right">{{ hora.cheque.toFixed(2) }} €</td>
                                    <td v-if="isValderrama" class="text-right">{{ hora.pagoSaldo.toFixed(2) }} €</td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr class="table-info">
                                    <td><strong>{{ $t("totalMesasPostit") }}</strong></td>
                                    <td></td>
                                    <td class="text-right text-success"><strong>{{
                                      getTotalVentasPositivas(filteredConsolidatedPostItTable).toFixed(2) }}
                                        €</strong>
                                    </td>
                                    <td class="text-right text-danger"><strong>{{
                                      getTotalCancelaciones(filteredConsolidatedPostItTable).toFixed(2) }} €</strong>
                                    </td>
                                    <td class="text-right"><strong>{{
                                      flatPostItTableData.summary.totalAmount.toFixed(2) }} €</strong></td>
                                    <td class="text-right"><strong>{{
                                      flatPostItTableData.summary.totalEfectivo.toFixed(2) }} €</strong></td>
                                    <td class="text-right"><strong>{{
                                      flatPostItTableData.summary.totalTarjeta.toFixed(2) }} €</strong></td>
                                    <td class="text-right"><strong>{{
                                        flatPostItTableData.summary.totalCheque.toFixed(2) }} €</strong></td>
                                    <td v-if="isValderrama" class="text-right"><strong>{{
                                        flatPostItTableData.summary.totalPagoSaldo.toFixed(2) }} €</strong></td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-show="graficaVentas !== 0">
              <div class="row">
                <div class="col-md-6">
                  <table class="table table-bordered table-striped tableVentas text-nowrap">
                    <thead class="thead-dark">
                      <tr style="cursor: pointer;">
                        <th>
                          {{ $t("fecha") }}
                        </th>

                        <th>
                          {{ $t("ventas") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="obj in data" style="cursor: pointer" class="trDay">
                        <template v-if="graficaVentas === 1">
                          <td>
                            <span style="text-transform: capitalize" :class="getClassDay(obj.initDate)">{{ obj.initDate
                              | getDiaDeSemana
                              }}</span>
                          </td>
                        </template>
                        <template v-else-if="graficaVentas === 2">
                          <td>
                            <span style="text-transform: capitalize">{{
                              obj.initDate | parseYear
                              }}</span>
                          </td>
                        </template>
                        <template v-else-if="graficaVentas === 3">
                          <td>
                            <span style="text-transform: capitalize">
                              {{ obj.initDate | parseMonth }}</span>
                          </td>
                        </template>
                        <template v-else-if="graficaVentas === 4">
                          <td>
                            <span>{{ getHour(obj) }}</span>
                          </td>
                        </template>

                        <td align="right">
                          <template v-if="graficaVentas !== 4">{{
                            (obj.money + obj.cards + obj.checks) | currency
                            }}
                          </template>
                          <template v-else>
                            <span> {{ getAmount(obj) | currency }} </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td class="table-success">
                          <strong>{{ $t("total") }}:</strong>
                        </td>
                        <td class="text-right table-success">
                          <strong>
                            <template>
                              <span> {{ this.getTotalVentas | currency }} </span>
                            </template>
                          </strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div class="col-md-6">
                  <div class="card">
                    <div class="chart-container col-md-12" style="height:300px; width: 100%;">
                      <canvas id="chartList"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="grafica !== 0">
            <div class="card">
              <div class="chart-container col-md-12" style="height:300px; width: 100%;">
                <canvas id="chart"></canvas>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="card">
            <div class="card-body">
              
              <div v-if="loadingResults" class="alert alert-warning mb-0">
                <i class="fa fa-spinner fa-spin"></i>
                {{ $t("cargandoDatos") }}...
              </div>

              <div v-else-if="!searchPerformed" class="alert mb-0" style="background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%); color: #ecf0f1;">
                Haga clic en el botón Consultar para realizar la búsqueda.
              </div>

              <div v-else class="alert alert-danger mb-0" role="alert">
                {{ $t("noHayVentasEnEsteRangoDeFechas") }}
              </div>

            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12">
        <vue-tabs @tab-change="handleTabChange" v-model="tabs">
          <v-tab title="Volver" icon="fa fa-arrow-circle-left"> </v-tab>
          <v-tab title="Cierre">
            <cierre v-if="tabs == 'Cierre'"
              :idBusiness="(this.sectores && this.$cookies.isKey('sectores') && idBusiness == -1) ? listaSectores.find((sector) => sector.id == idSector).idBusinessMaster : idBusiness"
              :idDay="idDay"></cierre>
          </v-tab>
          <v-tab title="Tickets">
            <tickets v-if="tabs == 'Tickets'" :idBusiness="idBusiness" :idDay="idDay" :idTpv="idTpv"></tickets>
          </v-tab>
          <v-tab title="Incidencias">
            <incidencias v-if="tabs == 'Incidencias'" :idBusiness="idBusiness" :idDay="idDay"></incidencias>
          </v-tab>
          <v-tab title="Agencias">
            <agencias v-if="tabs == 'Agencias'" :idBusiness="idBusiness" :idDay="idDay"></agencias>
          </v-tab>
        </vue-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Datetime from "vue-datetime";
import {
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Loading,
  Switch,
} from "element-ui";
import swal from "sweetalert2";
import { mapState, mapMutations } from 'vuex';
import moment from "moment";
import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
import bus from "../../../../bus";
import Cierre from "./Widgets/Cierre";
import Tickets from "./Widgets/Tickets";
import Incidencias from "./Widgets/Incidencias";
import Agencias from "./Widgets/Agencias";
import Terms from "../../../GeneralViews/Terms";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";

export default {
  created() {
    //this.loading = Loading.service({ text: this.$t('cargando') });
    this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorNegocio"));

    if (!this.sectores && !this.$cookies.isKey("sectores")) {
      //this.getBusiness();
      this.checkConfigCompany();

    } else {
      //this.getSectores();
      if (this.listaSectores.length > 1) {
        this.idSector = this.listaSectores[0].id;

        //Dentro, establecer un todos como primera opción y después llamar a getTpv()
        this.getBusinessesBySector();
      } else {
        //Cargar método local donde me traigo los sectores
        this.getSectores();
      }
    }

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },

  components: {
    Terms,
    CabeceraInformes,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Datetime.name]: Datetime,
    [ButtonGroup.name]: ButtonGroup,
    [Switch.name]: Switch,
    Cierre,
    Tickets,
    Incidencias,
    Agencias,
    Breadcrumb,
  },
  data() {
    CabeceraInformes;
    return {
      cargandoVentas: false,
      negociosConsultando: [],
      searchPerformed: false,
      loadingResults: false,
      currentRequestId: 0,
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),

      hoursfrom: "00:00:00",
      hoursto: "23:59:59",
      listBusinesses: [],
      listCompanies: [],
      idCompany: 0,
      data: [],
      listTpv: [],
      idTpv: -1,
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      cuentasAparcadas: false,
      dateInform: [],
      dateRangeOptions1Comercial: {
        firstDayOfWeek: 1,
      },
      idBusiness: 0,
      observar: 0,
      idsTPV: [],
      listCheckBoxTpv: [],
      busquedaPorHoras: false,
      busquedaPorApertura: false,
      ordenacionFecha: 0,
      ordenarEfectivo: 0,
      ordenarVentas: 0,
      ordenarTarjetas: 0,
      ordenarCheque: 0,
      ordenarBalance: 0,
      ordenarGastos: 0,
      ordenarCambio: 0,
      ordenarRetiradas: 0,
      ordenarTotal: 0,
      ordenarRecuento: 0,
      ordenarDescuadre: 0,
      ordenarSiguienteDia: 0,
      ordenarIncidencias: 0,
      ordenarRecaudado: 0,
      ordenarPropina: 0,
      openDay: false,
      tabs: "Cierre",
      idDay: 0,
      tickets: [],
      objectChart: null,
      objectChartList: null,
      grafica: 0,
      listGrafic: [],
      exportar: false,

      //Este bool oculta las columnas innecesarias en la opción "Buscar por horas"
      hideColumns: false,

      graficaVentas: 0,
      respuesta: true,
      filterSelected: 0,

      //GRAFICAS
      graficaMesas: 0,
      listMesasSales: [],

      despachos: false,
      dimoni: false,
      consultarInicioCuenta: false,
      porHoras: "",
      agrupacionPorEmpresa: false,

      filter: 0,
      filterTag: [
        { value: 0, label: this.$t('todos') },
        { value: 1, label: this.$t('socios') },
        { value: 2, label: this.$t('noSocios') },
        { value: 3, label: this.$t('empresa') }
      ],
      ventasAcumuladasPorDia: false,

      // Propiedades para ventas por horas y mesas
      showHourlyData: false,
      hourlyData: [],
      loadingHourlyData: false,
      selectedPlano: 'all',
    };
  },
  watch: {
    consultarInicioCuenta() {
      this.getVentas();
    },

    idBusiness(newVal) {
      // Obligamos a que el ID sea siempre un número para que no falle la búsqueda
      const estaCargando = this.negociosConsultando.some(id => Number(id) === Number(newVal));
      
      if (estaCargando) {
        // Si está en nuestra lista de espera: encendemos la amarilla
        this.searchPerformed = true;
        this.loadingResults = true;
        this.respuesta = null; // Limpiamos la roja/verde por si acaso
      } else {
        // Si no está en la lista: reset total para que salga la Azul
        this.searchPerformed = false;
        this.loadingResults = false;
        this.respuesta = null; 
        this.data = [];
      }
    },
  },
  computed: {
    ...mapState(["listaSectores", "sectores", "permiso"]),
    urlExportExcelCompleto() {
      let business = this.idBusiness;
      let sector;
      let url;

      if (!this.sectores && !this.$cookies.isKey("sectores")) {
        if (this.idsTPV.length <= 0) {
          this.idsTPV = [this.idTpv];
        }
        sector = false;
      } else {
        sector = true;
        business = this.idBusiness == -1 ? this.listaSectores[0].idBusinessMaster : this.idBusiness;
      }

      if (sector) {
        url = this.$store.getters.apiUrl +
          "/sales/exportAllTickets/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          0 +
          "&conExtras=" +
          1 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue +
          "&sectores=1";
      } else {
        url = this.$store.getters.apiUrl +
          "/sales/exportAllTickets/Excel?idTpv=" +
          this.idsTPV +
          "&idBusiness=" +
          business +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&conDetalles=" +
          0 +
          "&conExtras=" +
          1 +
          "&jwt=" +
          this.$store.getters.jwt +
          "&checkValue=" + this.checkValue;
      }
      return url;
    },
    urlExportPDF() {
      var tpv = "";
      this.idsTPV.forEach(function (d) {
        tpv += d + ",";
      });

      let idBusiness = this.idBusiness;
      let sector = 0
      let idCompany = "";

      if (this.sectores && this.$cookies.isKey('sectores') && this.idBusiness == -1) {

        idBusiness = this.listaSectores.find((sector) => sector.id == this.idSector).idBusinessMaster;
        sector = this.listaSectores.find((sector) => sector.id == this.idSector).name;

      } else if (this.idBusiness == -1) {

        idBusiness = this.listBusinesses[1].id;
        idCompany = "&idCompany=" + this.idCompany;
      }

      let url = this.$store.getters.apiUrl +
        "/products/exportVentasNegocio/PDF?idBusiness=" +
        idBusiness +
        "&idTpv=" +
        tpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt + idCompany;

      if (sector != 0) {
        url += "&sector=" + sector;
      }

      if (this.graficaMesas) {
        //return this.$store.getters.apiUrl + "/sales/exportVentasPorPlanos/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
      } else {
        return (url);
      }
    },
    urlExportDespachos() {
      let idTpv = this.idsTPV[0];

      let url = this.$store.getters.apiUrl +
        "/exportacionSage/exportacionSageDespachos?" +
        "idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt;

      return (
        url
      );
    },
    urlExportDespachosFecha() {
      let idTpv = this.idsTPV[0];
      let $datefromint = moment(this.datefrom).startOf("day").unix();
      let $datetoint = moment(this.dateto).endOf("day").unix();
      // console.log(this.exportar);
      if (($datetoint - $datefromint) > 2768399 && this.exportar) {
        this.exportar = false;
        swal({
          type: 'error',
          title: 'No se puede exportar más de un mes ',
          //text: 'Something went wrong!',
        })
      } else {
        this.exportar = false;
        let url = this.$store.getters.apiUrl +
          "/exportacionSage/exportacionSageDespachosFechas?" +
          "idTpv=" +
          idTpv +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&jwt=" +
          this.$store.getters.jwt;

        return (
          url
        );
      }
      this.exportar = false;
    },

    urlExportExcelHorasYMesas() {
      const idBusiness = this.idBusiness;
      // Formato YYYY-MM-DD para datefrom y dateto
      const $datefromstr = moment(this.datefrom).format("YYYY-MM-DD");
      const $datetostr = moment(this.dateto).format("YYYY-MM-DD");
      const $datefromint = moment(this.datefrom).startOf("day").unix();
      const $datetoint = moment(this.dateto).endOf("day").unix();
      const fechaDesHours = moment(this.hoursfrom, "HH:mm:ss").format("HH:mm:ss");
      const fechaHastHours = moment(this.hoursto, "HH:mm:ss").format("HH:mm:ss");

      if (($datetoint - $datefromint) > 2768399 && this.exportar) {
      this.exportar = false;
      swal({
        type: 'error',
        title: 'No se puede exportar más de un mes ',
      });
      return null;
      }

      this.exportar = false;

      const url = this.$store.getters.apiUrl +
      "/sales/exportVentasPorPlanosByHours?" +
      "idBusiness=" + idBusiness +
      "&datefrom=" + $datefromstr +
      "&dateto=" + $datetostr +
      "&hourFrom=" + fechaDesHours +
      "&hourTo=" + fechaHastHours +
      "&jwt=" + this.$store.getters.jwt;

      return url;
    },

    urlExportExcel() {
      var tpv = "";

      this.idsTPV.forEach(function (d) {
        tpv += d + ",";
      });

      let idBusiness = this.idBusiness;
      let filter = this.filter;
      let sector = 0
      let idCompany = "";

      if (this.sectores && this.$cookies.isKey('sectores') && this.idBusiness == -1) {
        idBusiness = this.listaSectores.find((sector) => sector.id == this.idSector).idBusinessMaster;
        sector = this.listaSectores.find((sector) => sector.id == this.idSector).name;
      } else if (this.idBusiness == -1) {

        idBusiness = this.listBusinesses[1].id;
        idCompany = "&idCompany=" + this.idCompany;
      }

      if (this.graficaMesas) {

        let url = this.$store.getters.apiUrl +
          "/sales/exportVentasPorPlanos/Excel?idBusiness=" +
          idBusiness +
          "&idTpv=" +
          tpv +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&filter=" +
          filter +
          "&jwt=" +
          this.$store.getters.jwt + idCompany;

        if (sector != 0) {
          url += "&sector=" + sector;
        }

        return (url);
      } else {

        let url = this.$store.getters.apiUrl +
          "/products/exportVentasNegocio/Excel?idBusiness=" +
          idBusiness +
          "&idTpv=" +
          tpv +
          "&datefrom=" +
          moment(this.datefrom)
            .startOf("day")
            .unix() +
          "&dateto=" +
          moment(this.dateto)
            .endOf("day")
            .unix() +
          "&jwt=" +
          this.$store.getters.jwt + idCompany;

        if (sector != 0) {
          url += "&sector=" + sector;
        }

        return (url);
      }
    },

    urlExportPDFInformes() {
      var tpv = "";

      this.idsTPV.forEach(function (d) {
        tpv += d + ",";
      });

      let idBusiness = this.idBusiness;
      let sector = 0;

      if (this.sectores && this.$cookies.isKey('sectores') && this.idBusiness == -1) {
        idBusiness = this.listaSectores.find((sector) => sector.id == this.idSector).idBusinessMaster;
        sector = this.listaSectores.find((sector) => sector.id == this.idSector).name;
      } else if (this.idBusiness == -1) {

        idBusiness = this.listBusinesses[1].id;

      }

      let url = this.$store.getters.apiUrl +
        "/products/exportVentasPorNegocio/PDF?idBusiness=" +
        idBusiness +
        "&idTpv=" +
        tpv +
        "&tipoVenta=" +
        this.graficaVentas +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;

      if (sector != 0) {
        url += "&sector=" + sector;
      }

      return (url);
    },
    urlExportExcelInformes() {
      var tpv = "";

      this.idsTPV.forEach(function (d) {
        tpv += d + ",";
      });

      let idBusiness = this.idBusiness;
      let sector = 0;

      if (this.sectores && this.$cookies.isKey('sectores') && this.idBusiness == -1) {
        idBusiness = this.listaSectores.find((sector) => sector.id == this.idSector).idBusinessMaster;
        sector = this.listaSectores.find((sector) => sector.id == this.idSector).name;
      } else if (this.idBusiness == -1) {

        idBusiness = this.listBusinesses[1].id;

      }

      let url = this.$store.getters.apiUrl +
        "/products/exportVentasPorNegocio/Excel?idBusiness=" +
        idBusiness +
        "&idTpv=" +
        tpv +
        "&tipoVenta=" +
        this.graficaVentas +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;

      if (sector != 0) {
        url += "&sector=" + sector;
      }

      return (url);
    },

    getTotalTarjeta() {
      let uds = 0;
      this.data.forEach(function (d) {
        uds += d.cards;
      });
      return uds;
    },
    getTotalCheque() {
      let partes = 0;
      this.data.forEach(function (d) {
        partes += d.checks;
      });
      return partes;
    },
    getTotalRetiradas() {
      let retiradas = 0;
      this.data.forEach(function (d) {
        retiradas += d.retiradas;
      });
      return retiradas;
    },
    getTotalEfectivo() {
      let partes = 0;
      this.data.forEach(function (d) {
        partes += d.money;
      });
      return partes;
    },
    getTotalMesas() {
      let total = 0;
      let vm = this;
      this.listMesasSales.forEach(function (d) {
        d.mesas.forEach(function (z) {
          total += z.amount;
        });
      });
      return total;
    },
    getTotalBalance() {
      let total = 0;
      this.data.forEach(d => {
        total += d.balance;
      });
      return total;
    },
    getTotalPropina() {
      let total = 0;
      this.data.forEach(d => {
        total += d.propina;
      });

      return total;
    },
    getTotalVentas() {
      let total = 0;
      let vm = this;
      this.data.forEach(function (d) {
        // console.log(d)
        if (vm.graficaVentas === 4) {

          // if(vm.busquedaPorHoras){
          //   total += parseFloat(d.money);
          // }else{
          //   total += parseFloat(d.amount);
          // }
          total += parseFloat(d.amount);

        } else {
          total += d.money + d.cards + d.checks;

          if (vm.dimoni) total += d.balance;
        }
      });
      return total;
    },
    getTotalVentasSinVentas() {
      let total = 0;
      let index = 0;
      let vm = this;
      this.data.forEach(function (d) {
        if (d.money + d.cards + d.checks !== 0) {
          total += d.money + d.cards + d.checks;

          if (vm.dimoni) total += d.balance;
          index++;
        }
      });
      return Math.round((total / index) * 100) / 100;
    },

    getTotalGastos() {
      let total = 0;
      this.data.forEach(function (d) {
        total += d.cashExpenses;
      });
      return total;
    },
    getTotalCambio() {
      let total = 0;
      this.data.forEach(function (d) {
        total += d.cashChange;
      });
      return total;
    },
    getTotalTotal() {
      let total = 0;
      let vm = this;
      this.data.forEach(function (d) {

        if (vm.dimoni) {
          total +=
            d.money +
            d.cards +
            d.checks +
            d.balance -
            d.cashExpenses +
            d.cashChange -
            d.retiradas;
        } else {
          total +=
            d.money +
            d.cards +
            d.checks -
            d.cashExpenses +
            d.cashChange -
            d.retiradas;
        }
      });
      return total;
    },
    getTotalRecuento() {
      let total = 0;
      this.data.forEach(function (d) {
        if (d.countAmount != 0) {
          total += d.countAmount - d.retiradas;
        } else {
          total += d.countAmount;
        }
      });
      return total;
    },
    getTotalRecaudado() {
      let total = 0;
      let vm = this;
      this.data.forEach(function (d) {
        if (d.countAmount !== 0) {
          total += d.countAmount - d.changeNextDay;
        }
      });
      return total;
    },
    getTotalDescuadre() {
      let total = 0;
      let vm = this;
      this.data.forEach(function (d) {
        if (d.countAmount !== 0) {
          if (vm.dimoni) {
            total +=
              Math.round((d.countAmount + d.cashExpenses)) -
              Math.round((d.money + d.cards + d.checks + d.cashChange + d.balance));
          } else {
            total +=
              (d.countAmount + d.cashExpenses).toFixed(2) -
              (d.money + d.cards + d.checks + d.cashChange).toFixed(2);
          }
        }
      });
      return total;
    },
    getTotalSiguiente() {
      let total = 0;
      this.data.forEach(function (d) {
        total += d.changeNextDay;
      });
      return total;
    },
    getTotalIncidencias() {
      let total = 0;
      this.data.forEach(function (d) {
        total += d.numIssues;
      });
      return total;
    },

    getTotalSesionMedia() {
      let total = 0;
      let sesiones = this.data.length;
      let vm = this;
      this.data.forEach(function (d) {

        total += d.money + d.cards + d.checks;

        if (vm.dimoni) total += d.balance;

      });
      return total / sesiones;
    },
    // Computed property para restructurar los datos por mesa en lugar de por salón
    hourlyDataByMesa() {
      if (!this.hourlyData || this.hourlyData.length === 0) {
        return [];
      }

      const mesasData = {};

      // Iterar sobre todos los salones
      this.hourlyData.forEach(salon => {
        // Iterar sobre todas las horas de cada salón
        salon.horas.forEach(hora => {
          // Iterar sobre todas las mesas de cada hora
          hora.mesas.forEach(mesa => {
            const mesaKey = `${salon.idPlano}_${mesa.number}`;

            if (!mesasData[mesaKey]) {
              mesasData[mesaKey] = {
                idPlano: salon.idPlano,
                salonName: salon.name,
                nametpv: salon.nametpv,
                mesaNumber: mesa.number,
                totalAmount: 0,
                totalEfectivo: 0,
                totalTarjeta: 0,
                totalCheque: 0,
                totalPagoSaldo: 0,
                horas: {}
              };
            }

            // Agregar datos de la hora actual
            if (!mesasData[mesaKey].horas[hora.hora]) {
              mesasData[mesaKey].horas[hora.hora] = {
                hora: hora.hora,
                amount: 0,
                efectivo: 0,
                tarjeta: 0,
                cheque: 0,
                pagoSaldo: 0,
                // ocupacion: 0,
                ventasPositivas: 0,
                cancelaciones: 0
              };
            }

            // Separar ventas positivas de cancelaciones negativas
            if (mesa.amount > 0) {
              // Es una venta positiva
              mesasData[mesaKey].horas[hora.hora].ventasPositivas += mesa.amount;
              mesasData[mesaKey].horas[hora.hora].amount += mesa.amount;
              mesasData[mesaKey].horas[hora.hora].efectivo += mesa.efectivo;
              mesasData[mesaKey].horas[hora.hora].tarjeta += mesa.tarjeta;
              mesasData[mesaKey].horas[hora.hora].cheque += mesa.cheque;
              mesasData[mesaKey].horas[hora.hora].pagoSaldo += mesa.amountPagoSaldo || 0;
              // mesasData[mesaKey].horas[hora.hora].ocupacion += mesa.ocupacion;
            } else if (mesa.amount < 0) {
              // Es una cancelación
              mesasData[mesaKey].horas[hora.hora].cancelaciones += Math.abs(mesa.amount);
              // Las cancelaciones se restan del total
              mesasData[mesaKey].horas[hora.hora].amount += mesa.amount;
              mesasData[mesaKey].horas[hora.hora].efectivo += mesa.efectivo;
              mesasData[mesaKey].horas[hora.hora].tarjeta += mesa.tarjeta;
              mesasData[mesaKey].horas[hora.hora].cheque += mesa.cheque;
              mesasData[mesaKey].horas[hora.hora].pagoSaldo += mesa.amountPagoSaldo || 0;
              // mesasData[mesaKey].horas[hora.hora].ocupacion += mesa.ocupacion;
            }

            // Sumar totales de la mesa (incluyendo cancelaciones)
            mesasData[mesaKey].totalAmount += mesa.amount;
            mesasData[mesaKey].totalEfectivo += mesa.efectivo;
            mesasData[mesaKey].totalTarjeta += mesa.tarjeta;
            mesasData[mesaKey].totalCheque += mesa.cheque;
            mesasData[mesaKey].totalPagoSaldo += mesa.amountPagoSaldo || 0;
          });
        });
      });

      // Convertir a array y ordenar por número de mesa de menor a mayor
      return Object.values(mesasData).sort((a, b) => {
        // Verificar si ambos son números
        const aNum = parseInt(a.mesaNumber);
        const bNum = parseInt(b.mesaNumber);

        // Si ambos son números válidos, ordenar por número
        if (!isNaN(aNum) && !isNaN(bNum)) {
          return aNum - bNum;
        }

        // Si uno es número y otro no, el número va primero
        if (!isNaN(aNum) && isNaN(bNum)) return -1;
        if (isNaN(aNum) && !isNaN(bNum)) return 1;

        // Si ambos son strings, ordenar alfabéticamente
        return a.mesaNumber.toString().localeCompare(b.mesaNumber.toString());
      });
    },

    // Computed para mesas regulares (no post-it)
    regularMesas() {
      return this.hourlyDataByMesa.filter(mesa => !this.isPostItTable(mesa));
    },

    // Computed para mesas de post-it
    postItMesas() {
      return this.hourlyDataByMesa.filter(mesa => this.isPostItTable(mesa));
    },

    // Computed para consolidar todas las mesas de post-it en una sola estructura
    consolidatedPostItTable() {
      const postItMesas = this.postItMesas;
      if (postItMesas.length === 0) return null;

      // Crear una estructura consolidada
      const consolidated = {
        idPlano: 'post-it-consolidated',
        salonName: 'Mesas de Post-it',
        nametpv: 'Consolidado',
        mesaNumber: 'POST-IT',
        totalAmount: 0,
        totalEfectivo: 0,
        totalTarjeta: 0,
        totalCheque: 0,
        totalPagoSaldo: 0,
        horas: {},
        postItEntries: [] // Array para almacenar las entradas individuales de post-it
      };

      // Procesar cada mesa de post-it
      postItMesas.forEach(mesa => {
        // Agregar entrada individual de post-it con el identificador completo
        const postItEntry = {
          postItName: mesa.mesaNumber, // Usar el campo number completo como identificador
          mesaData: mesa
        };
        consolidated.postItEntries.push(postItEntry);

        // Sumar totales
        consolidated.totalAmount += mesa.totalAmount;
        consolidated.totalEfectivo += mesa.totalEfectivo;
        consolidated.totalTarjeta += mesa.totalTarjeta;
        consolidated.totalCheque += mesa.totalCheque;
        consolidated.totalPagoSaldo += mesa.totalPagoSaldo;

        // Consolidar datos por hora
        Object.values(mesa.horas).forEach(hora => {
          if (!consolidated.horas[hora.hora]) {
            consolidated.horas[hora.hora] = {
              hora: hora.hora,
              amount: 0,
              efectivo: 0,
              tarjeta: 0,
              cheque: 0,
              pagoSaldo: 0,
              // ocupacion: 0,
              ventasPositivas: 0,
              cancelaciones: 0
            };
          }

          consolidated.horas[hora.hora].amount += hora.amount;
          consolidated.horas[hora.hora].efectivo += hora.efectivo;
          consolidated.horas[hora.hora].tarjeta += hora.tarjeta;
          consolidated.horas[hora.hora].cheque += hora.cheque;
          consolidated.horas[hora.hora].pagoSaldo += hora.pagoSaldo;
          // consolidated.horas[hora.hora].ocupacion += hora.ocupacion;
          consolidated.horas[hora.hora].ventasPositivas += hora.ventasPositivas;
          consolidated.horas[hora.hora].cancelaciones += hora.cancelaciones;
        });
      });

      return consolidated;
    },

    // Computed para obtener los planos únicos disponibles con nombres
    availablePlanos() {
      if (!this.hourlyData || this.hourlyData.length === 0) {
        return [];
      }

      const planosMap = new Map();
      let hasUnassignedTables = false;

      this.hourlyData.forEach(salon => {
        if (salon.idPlano) {
          // Usar el nombre del salón como nombre del plano, o crear un nombre por defecto
          const planoName = salon.name || `Plano ${salon.idPlano}`;
          planosMap.set(salon.idPlano, {
            id: salon.idPlano,
            name: planoName
          });
        } else {
          // Marcar que hay mesas sin plano asignado
          hasUnassignedTables = true;
        }
      });

      const planosArray = Array.from(planosMap.values()).sort((a, b) => {
        // Ordenar numéricamente si son números, alfabéticamente si son strings
        const aNum = parseInt(a.id);
        const bNum = parseInt(b.id);

        if (!isNaN(aNum) && !isNaN(bNum)) {
          return aNum - bNum;
        }

        return a.id.toString().localeCompare(b.id.toString());
      });

      // Agregar opción "Fuera de Plano" si hay mesas sin plano asignado
      if (hasUnassignedTables) {
        planosArray.unshift({
          id: 'unassigned',
          name: 'Fuera de Plano'
        });
      }

      return planosArray;
    },

    // Computed para filtrar mesas por plano seleccionado
    filteredRegularMesas() {
      if (!this.selectedPlano || this.selectedPlano === 'all') {
        return this.regularMesas;
      }

      if (this.selectedPlano === 'unassigned') {
        // Filtrar mesas que no tienen idPlano o tienen idPlano null/undefined/empty
        return this.regularMesas.filter(mesa => !mesa.idPlano || mesa.idPlano === null || mesa.idPlano === undefined || mesa.idPlano === '');
      }

      return this.regularMesas.filter(mesa => mesa.idPlano == this.selectedPlano);
    },

    // Computed para filtrar tabla consolidada de post-it por plano seleccionado
    filteredConsolidatedPostItTable() {
      if (!this.consolidatedPostItTable) return null;

      if (!this.selectedPlano || this.selectedPlano === 'all') {
        return this.consolidatedPostItTable;
      }

      let filteredEntries;
      if (this.selectedPlano === 'unassigned') {
        // Filtrar entradas de post-it que no tienen idPlano o tienen idPlano null/undefined/empty
        filteredEntries = this.consolidatedPostItTable.postItEntries.filter(entry =>
          !entry.mesaData.idPlano || entry.mesaData.idPlano === null || entry.mesaData.idPlano === undefined || entry.mesaData.idPlano === ''
        );
      } else {
        // Filtrar las entradas de post-it por plano
        filteredEntries = this.consolidatedPostItTable.postItEntries.filter(entry =>
          entry.mesaData.idPlano == this.selectedPlano
        );
      }

      if (filteredEntries.length === 0) return null;

      // Crear una nueva estructura consolidada con solo las entradas filtradas
      const filtered = {
        ...this.consolidatedPostItTable,
        postItEntries: filteredEntries,
        totalAmount: 0,
        totalEfectivo: 0,
        totalTarjeta: 0,
        totalCheque: 0,
        totalPagoSaldo: 0,
        horas: {}
      };

      // Recalcular totales basados en las entradas filtradas
      filteredEntries.forEach(entry => {
        filtered.totalAmount += entry.mesaData.totalAmount;
        filtered.totalEfectivo += entry.mesaData.totalEfectivo;
        filtered.totalTarjeta += entry.mesaData.totalTarjeta;
        filtered.totalCheque += entry.mesaData.totalCheque;
        filtered.totalPagoSaldo += entry.mesaData.totalPagoSaldo;

        // Consolidar datos por hora
        Object.values(entry.mesaData.horas).forEach(hora => {
          if (!filtered.horas[hora.hora]) {
            filtered.horas[hora.hora] = {
              hora: hora.hora,
              amount: 0,
              efectivo: 0,
              tarjeta: 0,
              cheque: 0,
              pagoSaldo: 0,
              ocupacion: 0,
              ventasPositivas: 0,
              cancelaciones: 0
            };
          }

          filtered.horas[hora.hora].amount += hora.amount;
          filtered.horas[hora.hora].efectivo += hora.efectivo;
          filtered.horas[hora.hora].tarjeta += hora.tarjeta;
          filtered.horas[hora.hora].cheque += hora.cheque;
          filtered.horas[hora.hora].pagoSaldo += hora.pagoSaldo;
          // filtered.horas[hora.hora].ocupacion += hora.ocupacion;
          filtered.horas[hora.hora].ventasPositivas += hora.ventasPositivas;
          filtered.horas[hora.hora].cancelaciones += hora.cancelaciones;
        });
      });

      return filtered;
    },

    // Computed para generar datos planos de la tabla de post-it
    flatPostItTableData() {
      if (!this.filteredConsolidatedPostItTable) return null;

      const flatData = {
        hourlyEntries: [], // Entradas horarias individuales para cada post-it
        consolidatedTotals: this.filteredConsolidatedPostItTable.horas, // Totales consolidados por hora
        summary: {
          totalAmount: this.filteredConsolidatedPostItTable.totalAmount,
          totalEfectivo: this.filteredConsolidatedPostItTable.totalEfectivo,
          totalTarjeta: this.filteredConsolidatedPostItTable.totalTarjeta,
          totalCheque: this.filteredConsolidatedPostItTable.totalCheque,
          totalPagoSaldo: this.filteredConsolidatedPostItTable.totalPagoSaldo
        }
      };

      // Generar entradas planas para cada post-it y cada hora
      this.filteredConsolidatedPostItTable.postItEntries.forEach(postItEntry => {
        Object.values(postItEntry.mesaData.horas).forEach(hora => {
          flatData.hourlyEntries.push({
            postItName: postItEntry.postItName,
            hora: hora.hora,
            ventasPositivas: hora.ventasPositivas,
            cancelaciones: hora.cancelaciones,
            amount: hora.amount,
            efectivo: hora.efectivo,
            tarjeta: hora.tarjeta,
            cheque: hora.cheque,
            pagoSaldo: hora.pagoSaldo,
            // ocupacion: hora.ocupacion
          });
        });
      });

      // Ordenar las entradas por hora y luego por nombre del post-it
      flatData.hourlyEntries.sort((a, b) => {
        if (a.hora !== b.hora) {
          return a.hora - b.hora;
        }
        return a.postItName.localeCompare(b.postItName);
      });

      return flatData;
    },

    // Computed property para identificar si es Valderrama
    isValderrama() {
      const idBusinessNum = parseInt(this.idBusiness);
      const result = idBusinessNum === 3824;
      return result;
    },
  },
  methods: {
    // Método para identificar si una mesa es una mesa de post-it
    isPostItTable(mesa) {
      // Verificar si el mesaNumber contiene "Post it:" al inicio
      return mesa.mesaNumber && typeof mesa.mesaNumber === 'string' &&
        mesa.mesaNumber.toLowerCase().startsWith('post it:');
    },
    // Método para calcular el total de ventas positivas de una mesa
    getTotalVentasPositivas(mesa) {
      if (!mesa || !mesa.horas) return 0;
      return Object.values(mesa.horas).reduce((total, hora) => {
        return total + (hora.ventasPositivas || 0);
      }, 0);
    },
    // Método para calcular el total de cancelaciones de una mesa
    getTotalCancelaciones(mesa) {
      if (!mesa || !mesa.horas) return 0;
      return Object.values(mesa.horas).reduce((total, hora) => {
        return total + (hora.cancelaciones || 0);
      }, 0);
    },
    ...mapMutations(['changeListaSectores']),
    styleCheckFilter(filterSelected) {
      return this.filterSelected == filterSelected;
    },
    abrirModal() {
      swal({
        title: this.$t("atencion"),
        text: this.$t("seleccionaUnTpv"),
        type: "info",
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: this.$t("deAcuerdo"),
        buttonsStyling: true,
      });
    },
    abrirModalVentasAcumuladasPorDia() {
      swal({
        title: this.$t("atencion"),
        text: this.$t("deshabilitarCheckboxVentasAcumuladasPorDia"),
        type: "info",
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: this.$t("deAcuerdo"),
        buttonsStyling: true,
      });
    },
    // Llamamos a este método antes de completar la tabla con los datos de las ventas. Si hemos habilitado el checkbox de ventasAcumuladasPorDia, el valor
    // del atributo de clase es true. Si es true, acumula los datos por día, sumando todos los valores. Si no es true, simplemente devuelve los datos originales.
    acumularVentasPorDia() {
      if (!this.ventasAcumuladasPorDia) {
        return this.data;
      }

      let arrayVentasAcumuladasPorDia = [];
      let fechaActual = null;
      let ventaAcumulada = null;

      // Iteramos sobre los datos de ventas
      this.data.forEach((obj) => {

        // Convertimos initDate a un formato de fecha completo (YYYY-MM-DD) para usar como clave de agrupación.
        const fechaObjeto = moment.unix(obj.initDate).format("YYYY-MM-DD");

        // Si la fecha actual es diferente a la que estamos procesando
        if (fechaObjeto !== fechaActual) {

          // Mira si ya hay una venta acumulada (es decir, no es el primer día que procesamos), y si es que sí, la agregamos al array
          if (ventaAcumulada) {
            arrayVentasAcumuladasPorDia.push(ventaAcumulada);
          }

          // Creamos un nuevo objeto de venta acumulada para el nuevo día y lo inicializamos con los datos del primer elemento de este día
          ventaAcumulada = { ...obj };
          // Actualizamos la fecha actual
          fechaActual = fechaObjeto;
        }
        // Si el día de la venta actual es el mismo que el día que estábamos procesando, simplemente sumamos los valores
        else {
          // Sumar los valores
          ventaAcumulada.money += obj.money;
          ventaAcumulada.cards += obj.cards;
          ventaAcumulada.checks += obj.checks;
          ventaAcumulada.propina += obj.propina;
          ventaAcumulada.balance += obj.balance;
          ventaAcumulada.cashExpenses += obj.cashExpenses;
          ventaAcumulada.cashChange += obj.cashChange;
          ventaAcumulada.retiradas += obj.retiradas;
          ventaAcumulada.countAmount += obj.countAmount;
          ventaAcumulada.changeNextDay += obj.changeNextDay;
          ventaAcumulada.numIssues += obj.numIssues;
        }
      });

      // Después de finalizar el bucle, si hay una venta acumulada pendiente, la agregamos al array de ventas acumuladas
      if (ventaAcumulada) {
        arrayVentasAcumuladasPorDia.push(ventaAcumulada);
      }
      // Finalmente, devolvemos el array con las ventas acumuladas por día
      return arrayVentasAcumuladasPorDia;
    },

    // Maneja las acciones que deben tomarse cuando el usuario hace clic en un elemento de la tabla
    handleClick(obj) {

      // Si no hay un TPV seleccionado (idTpv es -1) y hay más de un TPV en la lista (listTpv tiene más de un elemento),
      // se abre un modal para indicar que el usuario seleccione un TPV.
      if (this.idTpv == -1 && this.listTpv.length > 1) {
        this.abrirModal();
      }
      // Si la opción de ventas acumuladas por día está habilitada (ventasAcumuladasPorDia es verdadero),
      // se abre un modal específico para indicar que se deshabilite este checkbox.
      else if (this.ventasAcumuladasPorDia) {
        this.abrirModalVentasAcumuladasPorDia();
      }
      // Si ninguna de las condiciones anteriores se cumple, se le muestran al usuario los detalles de las ventas. 
      else {
        this.getCloseCash(obj.id);
      }
    },

    checkConfigCompany() {
      this.agrupacionPorEmpresa = false;

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/checkConfigCompanyAgrupation", config)
        .then(function (response) {
          if (response.data.response) {

            if (response.data.result.config) {
              vm.agrupacionPorEmpresa = true;
              vm.listCompanies = response.data.result.listCompanies;
              vm.idCompany = vm.listCompanies[0].id;

              vm.getBusinessesByCompany();
            } else {
              vm.getBusiness();
            }


          } else {
            if (vm.loading) vm.loading.close();
          }

        }).catch(function (error) {
          console.log(error);
        })
    },
    cambioSector(idSectorData, listBusinesses) {

      if (listBusinesses) {
        this.listBusinesses = listBusinesses;
      }

      this.idSector = idSectorData;
      this.idBusiness = -1;
      this.getAllTpvFromBusinesses();
    },
    //CABECERAS
    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      //this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;

      this.idTpv = -1;
      this.idsTPV = [];

      if (
        ((!this.sectores && !this.$cookies.isKey("sectores")) && idBusinessData != -1)
        || this.sectores && this.$cookies.isKey("sectores") && idBusinessData != -1
      ) {
        this.getTpv();
      } else {
        this.getAllTpvFromBusinesses();
      }

    },
    cambioCompany(idCompanyData, listBusinesses) {
      if (listBusinesses) {
        this.listBusinesses = listBusinesses;
      }
      //this.loading = Loading.service({ text: "Cargando..." });
      this.idCompany = idCompanyData;

      this.idBusiness = -1;
      this.idTpv = -1;

      this.getBusinessesByCompany();

    },
    emitirConsulta() {
      this.getVentas();
    },
    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
        this.changeTPV();
        this.disableVentasAcumuladas(false);
      }

      this.idTpv = idTpvData;
      //this.emitirConsulta();
    },
    cambioHora(dates) {
      // console.log('cambioHora received dates:', dates[0], dates[1]);
      this.datefrom = dates[0];
      this.dateto = dates[1];
      // console.log('Updated this.datefrom:', this.datefrom, 'this.dateto:', this.dateto);
      // console.log('Type of this.datefrom:', typeof this.datefrom, 'Type of this.dateto:', typeof this.dateto);
    },
    cambioBuscarPorHoras(bpH) {
      this.busquedaPorHoras = bpH;
    },
    cambioHorasBusqueda(hoursfrom, hoursto) {
      // console.log('cambioHorasBusqueda received hours:', hoursfrom, hoursto);
      this.hoursfrom = moment(hoursfrom).format("HH:mm:ss");
      this.hoursto = moment(hoursto).format("HH:mm:ss");
      // console.log('Updated this.hoursfrom:', this.hoursfrom, 'this.hoursto:', this.hoursto);
      // console.log('Type of this.hoursfrom:', typeof this.hoursfrom, 'Type of this.hoursto:', typeof this.hoursto);

    },
    buttonGraficaMesas() {
      this.filterSelected = 5;
      this.grafica = 0;
      this.graficaMesas = 1;
      this.graficaVentas = 0;
      this.filter = 0;

      this.getSalesMesas();
    },

    buttonGrafica() {
      if (this.filterSelected == 5) {
        this.filterSelected = 0;
      }

      this.graficaMesas = 0;

      if (this.grafica === 0) {
        this.grafica = 1;

        if (this.graficaVentas === 0) {
          this.grafica = 1;
          this.getVentasSinHoras();
        } else if (this.graficaVentas === 1) {
          this.grafica = 2;
          this.getSumaryWeeks();
        } else if (this.graficaVentas === 3) {
          this.grafica = 4;
          this.getVentasSinHoras();
        } else if (this.graficaVentas === 4) {
          this.grafica = 3;
          this.getSumaryHours();
        }
      } else {
        if (this.grafica === 1) {
          this.graficaVentas = 0;
          this.getVentasSinHoras();
        } else if (this.grafica === 2) {
          this.graficaVentas = 1;
          this.getVentasSinHoras();
        } else if (this.grafica === 3) {
          this.graficaVentas = 4;
          this.getVentasSinHoras();
        } else if (this.grafica === 4) {
          this.graficaVentas = 3;
          this.getVentasSinHoras();
        }

        this.grafica = 0;
      }
    },
    disableVentasAcumuladas() {
      if (this.ventasAcumuladasPorDia) {
        this.ventasAcumuladasPorDia = false; // Deshabilita el checkbox
        this.getVentasSinHoras(); // Fuerza el evento `@change`
      }
    },
    getHour(obj) {
      let hour = obj.horas ? obj.horas : obj.hour;

      return `${hour}:00`;
    },
    getAmount(obj) {
      return obj.amount ? obj.amount : obj.money;
    },
    sortedArrayFechaASC: function () {
      this.ordenacionFecha = 1;

      function compare(a, b) {
        if (a.initDate < b.initDate) return -1;
        if (a.initDate > b.initDate) return 1;
        return 0;
      }
      return this.data.sort(compare);
    },
    sortedArrayFechaDESC: function () {
      this.ordenacionFecha = 0;

      function compare(a, b) {
        if (a.initDate > b.initDate) return -1;
        if (a.initDate < b.initDate) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayVentasASC: function () {
      this.ordenarVentas = 1;

      function compare(a, b) {
        if (a.money + a.cards + a.checks < b.money + b.cards + b.checks)
          return -1;
        if (a.money + a.cards + a.checks > b.money + b.cards + b.checks)
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayVentasDESC: function () {
      this.ordenarVentas = 0;

      function compare(a, b) {
        if (a.money + a.cards + a.checks > b.money + b.cards + b.checks)
          return -1;
        if (a.money + a.cards + a.checks < b.money + b.cards + b.checks)
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayEfectivoASC: function () {
      this.ordenarEfectivo = 1;

      function compare(a, b) {
        if (a.money < b.money) return -1;
        if (a.money > b.money) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayEfectivoDESC: function () {
      this.ordenarEfectivo = 0;

      function compare(a, b) {
        if (a.money > b.money) return -1;
        if (a.money < b.money) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayTarjetasASC: function () {
      this.ordenarTarjetas = 1;

      function compare(a, b) {
        if (a.cards < b.cards) return -1;
        if (a.cards > b.cards) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayTarjetasDESC: function () {
      this.ordenarTarjetas = 0;

      function compare(a, b) {
        if (a.cards > b.cards) return -1;
        if (a.cards < b.cards) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayChequeASC: function () {
      this.ordenarCheque = 1;

      function compare(a, b) {
        if (a.checks < b.checks) return -1;
        if (a.checks > b.checks) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayChequeDESC: function () {
      this.ordenarCheque = 0;

      function compare(a, b) {
        if (a.checks > b.checks) return -1;
        if (a.checks < b.checks) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayPropinaASC: function () {
      this.ordenarPropina = 1;

      function compare(a, b) {
        if (a.propina < b.propina) return -1;
        if (a.propina > b.propina) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayPropinaDESC: function () {
      this.ordenarPropina = 0;

      function compare(a, b) {
        if (a.propina > b.propina) return -1;
        if (a.propina < b.propina) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayBalanceASC: function () {
      this.ordenarBalance = 1;

      function compare(a, b) {
        if (a.balance < b.balance) return -1;
        if (a.balance > b.balance) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayBalanceDESC: function () {
      this.ordenarBalance = 0;

      function compare(a, b) {
        if (a.balance > b.balance) return -1;
        if (a.balance < b.balance) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayGastosASC: function () {
      this.ordenarGastos = 1;

      function compare(a, b) {
        if (a.cashExpenses < b.cashExpenses) return -1;
        if (a.cashExpenses > b.cashExpenses) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayGastosDESC: function () {
      this.ordenarGastos = 0;

      function compare(a, b) {
        if (a.cashExpenses > b.cashExpenses) return -1;
        if (a.cashExpenses < b.cashExpenses) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayCambioASC: function () {
      this.ordenarCambio = 1;

      function compare(a, b) {
        if (a.cashChange < b.cashChange) return -1;
        if (a.cashChange > b.cashChange) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayCambioDESC: function () {
      this.ordenarCambio = 0;

      function compare(a, b) {
        if (a.cashChange > b.cashChange) return -1;
        if (a.cashChange < b.cashChange) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayRetiradasASC: function () {
      this.ordenarRetiradas = 1;

      function compare(a, b) {
        if (a.cashChange < b.cashChange) return -1;
        if (a.cashChange > b.cashChange) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayRetiradasDESC: function () {
      this.ordenarRetiradas = 0;

      function compare(a, b) {
        if (a.cashChange > b.cashChange) return -1;
        if (a.cashChange < b.cashChange) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayTotalASC: function () {
      this.ordenarTotal = 1;

      function compare(a, b) {
        if (
          a.money + a.cards + a.checks - a.cashExpenses + a.cashChange <
          b.money + b.cards + b.checks - b.cashExpenses + b.cashChange
        )
          return -1;
        if (
          a.money + a.cards + a.checks - a.cashExpenses + a.cashChange >
          b.money + b.cards + b.checks - b.cashExpenses + b.cashChange
        )
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayTotalDESC: function () {
      this.ordenarTotal = 0;

      function compare(a, b) {
        if (
          a.money + a.cards + a.checks - a.cashExpenses + a.cashChange >
          b.money + b.cards + b.checks - b.cashExpenses + b.cashChange
        )
          return -1;
        if (
          a.money + a.cards + a.checks - a.cashExpenses + a.cashChange <
          b.money + b.cards + b.checks - b.cashExpenses + b.cashChange
        )
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayRecuentoASC: function () {
      this.ordenarRecuento = 1;

      function compare(a, b) {
        if (a.countAmount < b.countAmount) return -1;
        if (a.countAmount > b.countAmount) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayRecuentoDESC: function () {
      this.ordenarRecuento = 0;

      function compare(a, b) {
        if (a.countAmount > b.countAmount) return -1;
        if (a.countAmount < b.countAmount) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayDescuadreASC: function () {
      this.ordenarDescuadre = 1;

      function compare(a, b) {
        if (
          a.countAmount -
          (a.money + a.cards + a.checks - a.cashExpenses + a.cashChange) <
          b.countAmount -
          (b.money + b.cards + b.checks - b.cashExpenses + b.cashChange)
        )
          return -1;
        if (
          a.countAmount -
          (a.money + a.cards + a.checks - a.cashExpenses + a.cashChange) >
          b.countAmount -
          (b.money + b.cards + b.checks - b.cashExpenses + b.cashChange)
        )
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayDescuadreDESC: function () {
      this.ordenarDescuadre = 0;

      function compare(a, b) {
        if (
          a.countAmount -
          (a.money + a.cards + a.checks - a.cashExpenses + a.cashChange) >
          b.countAmount -
          (b.money + b.cards + b.checks - b.cashExpenses + b.cashChange)
        )
          return -1;
        if (
          a.countAmount -
          (a.money + a.cards + a.checks - a.cashExpenses + a.cashChange) <
          b.countAmount -
          (b.money + b.cards + b.checks - b.cashExpenses + b.cashChange)
        )
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArraySiguienteDiaASC: function () {
      this.ordenarSiguienteDia = 1;

      function compare(a, b) {
        if (a.changeNextDay < b.changeNextDay) return -1;
        if (a.changeNextDay > b.changeNextDay) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArraySiguienteDiaDESC: function () {
      this.ordenarSiguienteDia = 0;

      function compare(a, b) {
        if (a.changeNextDay > b.changeNextDay) return -1;
        if (a.changeNextDay < b.changeNextDay) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayIncidenciasASC: function () {
      this.ordenarIncidencias = 1;

      function compare(a, b) {
        if (a.numIssues < b.numIssues) return -1;
        if (a.numIssues > b.numIssues) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayIncidenciasDESC: function () {
      this.ordenarIncidencias = 0;

      function compare(a, b) {
        if (a.numIssues > b.numIssues) return -1;
        if (a.numIssues < b.numIssues) return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayRecaudadoASC: function () {
      this.ordenarRecaudado = 1;

      function compare(a, b) {
        if (a.countAmount - a.changeNextDay < b.countAmount - b.changeNextDay)
          return -1;
        if (a.countAmount - a.changeNextDay > b.countAmount - b.changeNextDay)
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },
    sortedArrayRecaudadoDESC: function () {
      this.ordenarRecaudado = 0;

      function compare(a, b) {
        if (a.countAmount - a.changeNextDay > b.countAmount - b.changeNextDay)
          return -1;
        if (a.countAmount - a.changeNextDay < b.countAmount - b.changeNextDay)
          return 1;
        return 0;
      }

      return this.data.sort(compare);
    },

    openDays() {
      this.filterSelected = 0;
      this.graficaMesas = 0;
      this.consultarInicioCuenta = false;

      if (this.grafica !== 0) {
        this.grafica = 1;
        this.graficaVentas = 0;
        this.getVentasSinHoras();
      } else {
        this.graficaVentas = 0;
        this.getVentasSinHoras();
      }
    },

    openSemanas() {
      this.filterSelected = 1;
      this.graficaMesas = 0;
      this.consultarInicioCuenta = false;

      if (this.grafica !== 0) {
        this.graficaVentas = 1;
        this.grafica = 2;
        this.getSumaryWeeks();
      } else {
        this.graficaVentas = 1;
        this.getVentasSinHoras();
      }
    },
    openHours() {
      this.filterSelected = 4;
      this.graficaMesas = 0;

      if (this.grafica !== 0) {
        this.grafica = 3;
        this.graficaVentas = 4;
        this.getSumaryHours();
      } else {
        this.graficaVentas = 4;
        this.getVentasSinHoras();
      }
    },

    openMeses() {
      this.filterSelected = 2;
      this.graficaMesas = 0;
      this.consultarInicioCuenta = false;

      if (this.grafica !== 0) {
        this.grafica = 4;
        this.graficaVentas = 3;
        this.getVentasSinHoras();
      } else {
        this.graficaVentas = 3;
        this.getVentasSinHoras();
      }
    },

    openModal() {
      this.$modal.show("filtradoTPV");
    },
    getSectores() {
      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
        .then(function (response) {

          if (response.data.response) {

            response.data.result["sectores"].forEach((sector) => {
              sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
              sector.id = parseInt(sector.id);
            });

            vm.changeListaSectores(response.data.result["sectores"]);

            vm.idSector = vm.listaSectores[0].id;

            vm.getBusinessesBySector();
          }

        }).catch(function (error) {
          console.log(error);
        })
    },
    getBusinessesBySector() {
      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      var params = {
        idBusiness: this.listaSectores[0].idBusinessMaster,
        idSector: this.idSector,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;

      this.cargandoVentas = true;

      this.axios.post(this.$store.getters.apiUrl + "general/getBusinessesBySector", params, config)
        .then(function (response) {

          if (response.data.response) {
            vm.listBusinesses = response.data.result;
            vm.idBusiness = -1;

            vm.getAllTpvFromBusinesses();
          }

          vm.cargandoVentas = false;

        }).catch(function (error) {
          console.log(error);
          
          vm.cargandoVentas = false;
        })
    },
    hasSageDespacho() {
      if (this.idBusiness.length > 0) {
        var config = {
          params: {
            idTpv: this.listTpv[0].id,
            numConfig: '73',
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
          .then(function (response) {
            if (response.data.response == true) {
              vm.despachos = true;
            } else {
              vm.despachos = false;
            }
          }).catch(function (error) {
            console.log(error);
          });
      }
    },
    hasDimoni() {
      if (this.idBusiness.length > 0) {
        var config = {
          params: {
            idTpv: this.listTpv[0].id,
            numConfig: '83',
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
          .then(function (response) {
            if (response.data.response == true) {
              vm.dimoni = true;
            } else {
              vm.dimoni = false;
            }
          }).catch(function (error) {
            console.log(error);
          });
      }
    },
    getAllTpvFromBusinesses() {
      let businesses = [];

      this.listBusinesses.forEach(business => {

        if (business.id != -1) {
          businesses.push(parseInt(business.id));
        }

      });

      let config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusiness: businesses,
        },
        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listTpv = [];
            vm.idsTPV = [];

            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            //vm.idTpv = response.data.result[0].id;

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }

            //vm.getVentas();
            vm.grafica = 0;
          }
          // vm.loading.close();

        }).catch(function (error) {
          console.log(error);
        })
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          if (vm.idBusiness == 0) {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("licenciaCaducada"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
            vm.respuesta = false;

            getVentas()
          } else {
            vm.getTpv();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getBusinessesByCompany() {

      this.listBusinesses = [];

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idCompany: this.idCompany,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
        .then(function (response) {

          let printername = {
            establishmentName: "Todos",
            id: -1,
          };

          vm.listBusinesses.push(printername);

          response.data.result.forEach(result => {
            vm.listBusinesses.push(result);
          });
          //vm.listBusinesses = response.data.result;
          vm.idBusiness = -1;
          vm.getAllTpvFromBusinesses();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTpv() {
      this.listTpv = [];
      this.idsTPV = [];
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listTpv = [];
            vm.idsTPV = [];

            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            //vm.idTpv = response.data.result[0].id;

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }

            //vm.getVentas();
            vm.hasSageDespacho();
            vm.hasDimoni();
            vm.grafica = 0;
          }
          // vm.loading.close();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeTPV() {
      if (this.idTpv === -1) {
        this.idsTPV = [];

        for (let i = 0; i < this.listTpv.length; i++) {
          this.idsTPV.push(this.listTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }
    },
    getVentas() {
      this.$modal.hide("filtradoTPV");

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        if (this.busquedaPorHoras) {
          this.hideColumns = true;
          this.getVentasConHoras();
        } else {
          this.hideColumns = false;
          this.getVentasSinHoras();
          if (this.graficaVentas === 1) {
            this.getSumaryWeeks();
          }
          //this.getSumaryWeeks();
        }
        //this.getSalesMesas();
      }

    },
    getVentasSinHoras() {
      let secondsDesde = moment(this.datefrom)
        .startOf("day")
        .unix();
      let secondsHasta = moment(this.dateto)
        .endOf("day")
        .unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        //this.loading = Loading.service({ text: this.$t('cargando') });

        this.searchPerformed = true;
        this.loadingResults = true;
        this.respuesta = null;
        this.data = [];
        
        this.currentRequestId++;
        const requestId = this.currentRequestId;

        let idNegocio;

        if (parseInt(this.idBusiness) == -1) {

          if (this.sectores && this.$cookies.isKey('sectores')) {
            idNegocio = parseInt(this.listaSectores[0].idBusinessMaster);
          } else {
            idNegocio = parseInt(this.listBusinesses[1].id);
          }

        } else {
          idNegocio = parseInt(this.idBusiness);
        }

        if (this.consultarInicioCuenta) {
          var config = {
            params: {
              idBusiness: idNegocio,
              idTpv: this.idsTPV,
              datefrom: secondsDesde,
              dateto: secondsHasta,
              porHoras: "true",
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };
        } else {
          var config = {
            params: {
              idBusiness: idNegocio,
              idTpv: this.idsTPV,
              datefrom: secondsDesde,
              dateto: secondsHasta,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };
        }

        let controller = "";

        if (this.graficaVentas === 0) {
          controller = "getSalesByBusiness";
        } else if (this.graficaVentas === 1) {
          controller = "getSalesByBusinessWeek";
        } else if (this.graficaVentas === 3) {
          controller = "getSalesByBusinessMonth";
        } else if (this.graficaVentas === 4) {
          controller = "getSalesByBusinessHours";
        } else {
          controller = "getSalesByBusinessYear";
        }

        let vm = this;

        if (this.idBusiness != -1 || !this.sectores && !this.$cookies.isKey('sectores')) {
          this.$store.dispatch("setIdBusiness", this.idBusiness);
        }

        let negocioActual = Number(this.idBusiness);
        if (!this.negociosConsultando.includes(negocioActual)) {
          this.negociosConsultando.push(negocioActual);
        }

        this.axios
          .get(this.$store.getters.apiUrl + "products/" + controller, config)
          .then(function (response) {
            vm.negociosConsultando = vm.negociosConsultando.filter(id => Number(id) !== Number(negocioActual));
            if (Number(vm.idBusiness) === negocioActual) {
              if (requestId !== vm.currentRequestId) return;

              vm.loadingResults = false;
              if (response.data.response) {
                vm.data = "";
                vm.data = response.data.result;
                if (vm.graficaVentas === 0) {
                  vm.initChart();
                } else {
                  vm.initChartLista();
                }

                if (vm.grafica === 4) {
                  vm.initChartWeek();
                }

                vm.respuesta = true;
              } else if (response.data.response == false && response.data.rangoMayor == true) {
                swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info", // se puede usar warning
                });
                vm.respuesta = false;
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              if (vm.loading) vm.loading.close();
            }
          })
          .catch(function (error) {
            vm.negociosConsultando = vm.negociosConsultando.filter(id => Number(id) !== Number(negocioActual));
            if (Number(vm.idBusiness) === negocioActual) {
              vm.loadingResults = false;
            }
            console.log(error);
          });
      }
    },
    getVentasConHoras() {
      let secondsDesde = moment(this.datefrom).startOf("day").unix();
      let secondsHasta = moment(this.dateto).endOf("day").unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        this.searchPerformed = true;
        this.loadingResults = true;
        this.respuesta = null;
        this.data = [];

        this.currentRequestId++;
        const requestId = this.currentRequestId;

        let fechaDesHours = moment(this.hoursfrom, "HH:mm:ss").format("HH:mm:ss");
        let fechaHastHours = moment(this.hoursto, "HH:mm:ss").format("HH:mm:ss");

        let idNegocio;
        if (parseInt(this.idBusiness) == -1) {
          if (this.sectores && this.$cookies.isKey('sectores')) {
            idNegocio = parseInt(this.listaSectores[0].idBusinessMaster);
          } else {
            idNegocio = parseInt(this.listBusinesses[1].id);
          }
        } else {
          idNegocio = parseInt(this.idBusiness);
        }

        var config = {
          params: {
            idBusiness: idNegocio,
            idTpv: this.idsTPV,
            busquedaPorApertura: this.consultarInicioCuenta,
            datefrom: secondsDesde,
            dateto: secondsHasta,
            hoursfrom: fechaDesHours,
            hoursto: fechaHastHours,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        if (this.idBusiness != -1 || !this.sectores && !this.$cookies.isKey('sectores')) {
          this.$store.dispatch("setIdBusiness", this.idBusiness);
        }

        let negocioActual = Number(this.idBusiness);
        if (!this.negociosConsultando.includes(negocioActual)) {
          this.negociosConsultando.push(negocioActual);
        }

          if (this.graficaVentas === 4) {
            this.axios
              .get(this.$store.getters.apiUrl + "products/getSalesByBusinessByHoursFilter", config)
              .then(function (response) {
                vm.negociosConsultando = vm.negociosConsultando.filter(id => Number(id) !== Number(negocioActual));

                if (Number(vm.idBusiness) === negocioActual) {
                  if (requestId !== vm.currentRequestId) return;
                  vm.loadingResults = false;
                  if (response.data.response) {
                    vm.data = response.data.result;
                    vm.respuesta = true;
                  } else {
                    swal({
                      title: vm.$t("atencion"),
                      text: response.data.message,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "error",
                    });
                    vm.respuesta = false;
                  }
                  if (vm.loading) vm.loading.close();
                }
              })
              .catch(function (error) {
                vm.negociosConsultando = vm.negociosConsultando.filter(id => Number(id) !== Number(negocioActual));
                if (Number(vm.idBusiness) === negocioActual) {
                  vm.loadingResults = false;
                }
                console.log(error);
              });
          } else {
            this.axios
              .get(this.$store.getters.apiUrl + "products/getSalesByBusinessByHours", config)
              .then(function (response) {
                vm.negociosConsultando = vm.negociosConsultando.filter(id => Number(id) !== Number(negocioActual));

                if (Number(vm.idBusiness) === negocioActual) {
                  if (requestId !== vm.currentRequestId) return;
                  vm.loadingResults = false;
                  if (response.data.response) {
                    vm.data = response.data.result;
                    vm.respuesta = true;
                  } else {
                    swal({
                      title: vm.$t("atencion"),
                      text: response.data.message,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "error",
                    });
                    vm.respuesta = false;
                  }
                  if (vm.loading) vm.loading.close();
                }
              })
              .catch(function (error) {
                vm.negociosConsultando = vm.negociosConsultando.filter(id => Number(id) !== Number(negocioActual));
                if (Number(vm.idBusiness) === negocioActual) {
                  vm.loadingResults = false;
                }
                console.log(error);
              });
          }
      }
    },

    getSalesMesas() {
      let secondsDesde = moment(this.datefrom)
        .startOf("day")
        .unix();
      let secondsHasta = moment(this.dateto)
        .endOf("day")
        .unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        //this.loading = Loading.service({ text: this.$t('cargando') });

        let idNegocio;

        if (parseInt(this.idBusiness) == -1) {

          if (this.sectores && this.$cookies.isKey('sectores')) {
            idNegocio = parseInt(this.listaSectores[0].idBusinessMaster);
          } else {
            idNegocio = parseInt(this.listBusinesses[1].id);
          }

        } else {
          idNegocio = parseInt(this.idBusiness);
        }

        var config = {
          params: {
            idBusiness: idNegocio,
            idTpv: this.idsTPV,
            datefrom: secondsDesde,
            dateto: secondsHasta,
            filter: this.filter,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let controller = "getSumaryPlanos";

        let vm = this;

        if (this.idBusiness != -1 || !this.sectores && !this.$cookies.isKey('sectores')) {
          this.$store.dispatch("setIdBusiness", this.idBusiness);
        }

        this.axios
          .get(this.$store.getters.apiUrl + "sales/" + controller, config)
          .then(function (response) {
            if (response.data.response) {
              vm.listMesasSales = response.data.result;

              vm.respuesta = true;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });

              vm.respuesta = false;
            }
            if (vm.loading) vm.loading.close();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getCloseCash(idDay) {
      if (this.idTpv === 0 && this.listTpv.length > 2) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("necesitasElegirUnTpvParaPoderVerLosDetallesDeEste"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.openDay = true;
        this.idDay = idDay;
        this.tabs = "Cierre";
        this.$modal.hide("filtradoTPV");
      }
    },
    getClassDay(date) {
      var classDay = "";
      var humanDate = moment.unix(date);
      var dia = moment(humanDate).format("d");

      if (dia === "0") {
        classDay = "sunday";
      } else if (dia == 5 || dia == 6) {
        classDay = "fridaySaturday";
      }

      return classDay;
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      //TODO
      this.tabs = newTab.title;
      if (this.tabs == "Volver") {
        this.openDay = false;
        this.idDay = 0;
      }
    },

    getSumaryWeeks() {
      let secondsDesde = moment(this.datefrom)
        .startOf("day")
        .unix();
      let secondsHasta = moment(this.dateto)
        .endOf("day")
        .unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        //this.loading = Loading.service({ text: this.$t('cargando') });

        var config = {
          params: {
            idBusiness: this.idBusiness == -1 && this.sectores && this.$cookies.isKey('sectores') ? this.listaSectores[0].idBusinessMaster : this.idBusiness,
            idTpv: this.idsTPV,
            datefrom: secondsDesde,
            dateto: secondsHasta,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;

        if (this.idBusiness != -1 || !this.sectores && !this.$cookies.isKey('sectores')) {

          this.$store.dispatch("setIdBusiness", this.idBusiness);
        }


        this.axios
          .get(this.$store.getters.apiUrl + "sales/getSumaryWeeks", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listGrafic = response.data.result;
              vm.initChartWeek();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
            if (vm.loading) vm.loading.close();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    getSumaryHours() {
      let secondsDesde = moment(this.datefrom)
        .startOf("day")
        .unix();
      let secondsHasta = moment(this.dateto)
        .endOf("day")
        .unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        //this.loading = Loading.service({ text: this.$t('cargando') });

        var config = {
          params: {
            idBusiness: this.idBusiness == -1 && this.sectores && this.$cookies.isKey('sectores') ? this.listaSectores[0].idBusinessMaster : this.idBusiness,
            idTpv: this.idsTPV,
            datefrom: secondsDesde,
            dateto: secondsHasta,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        if (this.idBusiness != -1 || !this.sectores && !this.$cookies.isKey('sectores')) {

          this.$store.dispatch("setIdBusiness", this.idBusiness);

        }
        this.axios
          .get(this.$store.getters.apiUrl + "sales/getSumaryHours", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listGrafic = response.data.result;

              vm.initChartWeek();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
            if (vm.loading) vm.loading.close();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    initChartLista() {
      if (this.graficaVentas === 0) {
        let vm = this;
        var labels = this.data.map(function (x) {
          return moment.unix(x.initDate).format("DD-MM-YYYY");
        });
      } else if (this.graficaVentas === 1) {
        let vm = this;
        var labels = this.data.map(function (x) {
          var humanDate = moment.unix(x.initDate);
          return moment(humanDate).format("dddd");
        });
      } else if (this.graficaVentas === 3) {
        let vm = this;
        var labels = this.data.map(function (x) {
          var humanDate = moment.unix(x.initDate);
          return moment(humanDate).format("MMMM");
        });
      } else if (this.graficaVentas === 4) {
        let vm = this;
        var labels = this.data.map(function (x) {
          // return moment.unix(x.initDate).format("HH:00");
          return x.horas + ":00"
        });
      }

      let total = 0;
      let count = 0;

      if (
        this.graficaVentas === 1 ||
        this.graficaVentas === 2 ||
        this.graficaVentas === 3
      ) {
        var data = this.data.map(function (x) {
          return x.money + x.checks + x.cards;
        });
      } else {
        var data = this.data.map(function (x) {
          return x.amount;
        });
      }

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      if (this.objectChartList !== null) {
        this.objectChartList.destroy();
      }

      this.objectChartList = new Chart("chartList", {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: "rgba(192,214,8,0.3)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: false,
            position: "bottom",
          },
          maintainAspectRatio: false,
        },
      });
    },

    initChart() {
      let vm = this;
      var labels = this.data.map(function (x) {
        return moment.unix(x.initDate).format("DD-MM-YYYY");
      });

      let total = 0;
      let count = 0;

      var labelsMedia = this.data.map(function (x) {
        count++;
        total += x.money + x.checks + x.cards;

        return total / count;
      });

      var data = this.data.map(function (x) {
        return x.money + x.checks + x.cards;
      });

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      if (this.objectChart !== null) {
        this.objectChart.destroy();
      }

      this.objectChart = new Chart("chart", {
        type: "line",
        data: {
          labels: labels,
          datasets: [
            {
              data: labelsMedia,
              borderWidth: 3,
              backgroundColor: "rgba(168,0,0,0.3)",
              borderColor: "rgba(168,0,0,0.3)",
              type: "line",
              fill: false,
            },
            {
              data: data,
              backgroundColor: "rgba(192,214,8,0.3)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: false,
            position: "bottom",
          },
          maintainAspectRatio: false,
        },
      });
    },

    initChartWeek() {
      if (this.grafica == 2) {
        let vm = this;
        var labels = this.listGrafic.map(function (x) {
          return x.dias;
        });

        var data = this.listGrafic.map(function (x) {
          return x.amount;
        });
      } else if (this.grafica == 3) {
        let vm = this;
        var labels = this.listGrafic.map(function (x) {
          return x.horas + " h";
        });

        var data = this.listGrafic.map(function (x) {
          return x.amount;
        });
      } else if (this.grafica == 4) {
        let vm = this;
        var labels = this.data.map(function (x) {
          var humanDate = moment.unix(x.initDate);

          return moment(humanDate).format("MMMM");
        });

        var data = this.data.map(function (x) {
          return x.money + x.checks + x.cards;
        });
      }

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function (x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      if (this.objectChart !== null) {
        this.objectChart.destroy();
      }

      this.objectChart = new Chart("chart", {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: false,
            position: "bottom",
          },
          maintainAspectRatio: false,
        },
      });
    },

    // Método para obtener ventas por horas y mesas
    async getVentasPorHorasYMesas() {
      // Solo obtener datos si se está buscando por horas
      if (!this.busquedaPorHoras) {
        swal({
          title: this.$t("ups"),
          text: "Debe activar la búsqueda por horas para obtener este reporte",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "warning",
        });
        return;
      }

      // Obtener los valores actuales directamente del componente CabeceraInformes
      let currentDatefrom = this.datefrom;
      let currentDateto = this.dateto;
      let currentHoursfrom = this.hoursfrom;
      let currentHoursto = this.hoursto;

      // Buscar el componente CabeceraInformes y obtener sus valores actuales
      const cabeceraComponent = this.$children.find(child =>
        child.$options.name === 'CabeceraInformes' ||
        child.$options._componentTag === 'cabecera-informes' ||
        child.$options.__file && child.$options.__file.includes('CabeceraInformes')
      );

      if (cabeceraComponent) {
        // Usar los valores del componente hijo si están disponibles
        if (cabeceraComponent.dates && cabeceraComponent.dates.length >= 2) {
          currentDatefrom = cabeceraComponent.dates[0];
          currentDateto = cabeceraComponent.dates[1];
        }
        if (cabeceraComponent.hoursdesde) {
          currentHoursfrom = moment(cabeceraComponent.hoursdesde).format("HH:mm:ss");
        }
        if (cabeceraComponent.hourshasta) {
          currentHoursto = moment(cabeceraComponent.hourshasta).format("HH:mm:ss");
        }
      }

      // console.log('getVentasPorHorasYMesas called with: datefrom=', currentDatefrom, 'dateto=', currentDateto, 'hoursfrom=', currentHoursfrom, 'hoursto=', currentHoursto);
      // console.log('Types in getVentasPorHorasYMesas - datefrom:', typeof currentDatefrom, 'dateto:', typeof currentDateto, 'hoursfrom:', typeof currentHoursfrom, 'hoursto:', typeof currentHoursto);

      this.loadingHourlyData = true;
      this.showHourlyData = false;
      //this.loading = Loading.service({ text: this.$t('cargando') });

      try {
        let idNegocio;

        if (parseInt(this.idBusiness) == -1) {
          if (this.sectores && this.$cookies.isKey('sectores')) {
            idNegocio = parseInt(this.listaSectores[0].idBusinessMaster);
          } else {
            idNegocio = parseInt(this.listBusinesses[1].id);
          }
        } else {
          idNegocio = parseInt(this.idBusiness);
        }

        const params = {
          idBusiness: idNegocio,
          datefrom: moment(currentDatefrom).format('YYYY-MM-DD'),
          dateto: moment(currentDateto).format('YYYY-MM-DD'),
          filter: this.filter,
          hourFrom: currentHoursfrom ? moment(currentHoursfrom, "HH:mm:ss").format("HH:mm") : null,
          hourTo: currentHoursto ? moment(currentHoursto, "HH:mm:ss").format("HH:mm") : null,
          jwt: this.$store.getters.jwt
        };

        const { data } = await this.axios.get(
          this.$store.getters.apiUrl + "sales/getSumaryPlanosByHours",
          {
            params,
            headers: { Authorization: "Bearer " + this.$store.getters.jwt }
          }
        );

        if (data.response) {
          this.hourlyData = data.result;
          this.showHourlyData = true;
          if (this.loading) this.loading.close();

          // Scroll hacia la sección de datos por horas
          this.$nextTick(() => {
            const hourlyDataSection = document.querySelector('.showHourlyData');
            if (hourlyDataSection) {
              hourlyDataSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          });
        } else {
          swal({
            title: this.$t("ups"),
            text: data.result || "No se pudieron obtener los datos por horas",
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
          this.showHourlyData = false;
          if (this.loading) this.loading.close();
        }
      } catch (error) {
        console.error('Error al obtener ventas por horas:', error);
        swal({
          title: this.$t("ups"),
          text: "Error al obtener los datos por horas",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        this.showHourlyData = false;
        if (this.loading) this.loading.close();
      } finally {
        this.loadingHourlyData = false;
        if (this.loading) this.loading.close();
      }
    },
  },
};
</script>

<style scoped>
.consultarSwitch {
  padding-top: 6px;
}

.el-switch {
  margin: 6px;
  margin-bottom: 5px;
}

.active-filter {
  color: #1E22AA;
  border-color: #b9d0d7;
  background-color: #e8eff2;
}

.active-filter-mesas {
  background-color: #f38a09;
  border-color: #b9d0d7;
}

a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.sunday {
  color: rgb(128, 0, 0);
}

.fridaySaturday {
  color: rgb(0, 128, 64);
}

.trDay:hover {
  background-color: rgba(68, 125, 247, 0.2) !important;
}

.justify-content-right {
  margin-left: 15px;
}

.export-controls-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 15px;
}

.export-controls-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.export-dropdown-section {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ventas-por-horas-btn {
  margin-left: 10px;
}

.filter-selector {
  margin-left: 15px;
}

.export-controls-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.checkbox-section {
  display: flex;
  align-items: center;
}

.button-group-container {
  display: flex;
  align-items: center;
}

.filter-button-group {
  display: flex;
  flex-shrink: 0;
}

.filter-button-group .el-button {
  margin: 0;
  border-radius: 0;
}

.filter-button-group .el-button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.filter-button-group .el-button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* Responsive */
@media (max-width: 991px) {
  .export-controls-container {
    flex-direction: column;
    align-items: stretch;
  }

  .export-controls-left,
  .export-controls-right {
    justify-content: center;
  }

  .export-dropdown-section {
    justify-content: center;
    width: 100%;
  }
}

@media (max-width: 767px) {

  .export-controls-left,
  .export-controls-right {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .export-dropdown-section {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .ventas-por-horas-btn {
    margin-left: 0;
  }

  .filter-selector {
    margin-left: 0;
  }

  .export-controls-right {
    gap: 15px;
  }

  .button-group-container {
    width: 100%;
    justify-content: center;
  }

  .filter-button-group {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    max-width: 100%;
  }

  .filter-button-group .el-button {
    white-space: nowrap;
    flex-shrink: 0;
  }
}

/* .mt-4 {
  margin-top: 1.5rem;
} */

/* .mb-4 {
  margin-bottom: 1.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
} */

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

/* .badge-success {
  color: #fff;
  background-color: #28a745;
}

.badge-info {
  color: #fff;
  background-color: #17a2b8;
} */

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}

.text-primary {
  color: #007bff !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-info {
  background-color: #d1ecf1;
}

.table-secondary {
  background-color: #e2e3e5;
}

.table-warning {
  background-color: #fff3cd;
}

.thead-dark {
  background-color: #343a40;
  color: #fff;
}

/* Estilos para el selector de planos */
.plano-selector {
  display: flex;
  align-items: center;
}

.plano-selector .el-select {
  margin-left: 15px;
}

@media (max-width: 768px) {
  .card-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;
  }

  .plano-selector {
    margin-top: 10px;
    margin-left: 0;
  }

  .plano-selector .el-select {
    width: 100% !important;
    margin-left: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/VentasNegocios.vue